(() => {
  // personalisation-product-integration/city-map-pilot/field-focus-guide.mjs
  function mapTextSlots(design, mm) {
    const h = 900 * mm[1] / mm[0], slot = (x, y, size, align = "center") => ({ x, y, size, align });
    if (design === "atlas") return { placeLabel: slot(450, 163, 78), subtitle: slot(450, 203, 13), heading: slot(450, h - 140, 13), names: slot(450, h - 103, 13), date: slot(450, h - 103, 13) };
    if (["colour", "monochrome"].includes(design)) return { placeLabel: slot(49, h - 120, 91, "left"), subtitle: slot(55, h - 80, 13, "left"), heading: slot(55, h - 219, 13, "left"), names: slot(55, h - 43, 12, "left"), date: slot(55, h - 43, 12, "left") };
    const bottom = 164 + Math.min(684, h - 578);
    return { placeLabel: slot(450, bottom + 66, 58), subtitle: slot(450, 104, 13), heading: slot(450, bottom + 123, 29), names: slot(450, h - 191, 24), date: slot(450, h - 152, 13) };
  }
  function createMapFieldFocusGuide({ root: root2, surface, canvas: canvas2, design, showPrint }) {
    const dialog = root2.closest("dialog"), host = canvas2.parentElement, ns = "http://www.w3.org/2000/svg";
    const overlay = document.createElement("div");
    overlay.className = "laboo-map-field-guide";
    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    host.append(overlay);
    let field = "", boxes = {}, paper = [900, 1273], lastMobile = "";
    const mobile = window.matchMedia("(max-width:767px)");
    const mobileFields = { title: "placeLabel", subtitle: "subtitle", message: "heading", names: "names", date: "date" };
    function refresh() {
      const allowed = dialog?.open && dialog.dataset.pfStage === "2" && dialog.dataset.pfInternal === "1";
      const box = boxes[field], rect = JSON.parse(canvas2.dataset.artworkRect || "null");
      overlay.hidden = !(allowed && box && rect && canvas2.dataset.galleryScene === "0" && surface.getAttribute("aria-busy") !== "true");
      if (overlay.hidden) return;
      const c = canvas2.getBoundingClientRect(), p = host.getBoundingClientRect(), style = getComputedStyle(canvas2), fit = style.objectFit;
      const scale = (fit === "cover" ? Math.max : Math.min)(c.width / canvas2.width, c.height / canvas2.height), w = canvas2.width * scale, h = canvas2.height * scale;
      const x = c.left - p.left + host.scrollLeft + (c.width - w) / 2, y = c.top - p.top + host.scrollTop + (c.height - h) / 2;
      const left = x + w * (rect[0] + rect[2] * box.x / paper[0]), top = y + h * (rect[1] + rect[3] * box.y / paper[1]);
      overlay.style.left = left + "px";
      overlay.style.top = top + "px";
      overlay.style.width = w * rect[2] * box.width / paper[0] + "px";
      overlay.style.height = h * rect[3] * box.height / paper[1] + "px";
      overlay.dataset.field = field;
    }
    function activate(key) {
      field = key || "";
      if (field && dialog?.open && dialog.dataset.pfStage === "2" && canvas2.dataset.galleryScene !== "0") showPrint();
      refresh();
    }
    root2.addEventListener("focusin", (e) => {
      if (e.target.matches("[data-map-field]")) activate(e.target.dataset.mapField);
    });
    new ResizeObserver(refresh).observe(canvas2);
    new MutationObserver(() => {
      const id = dialog.dataset.mobileEdit;
      if (mobile.matches && id !== lastMobile) {
        lastMobile = id;
        activate(mobileFields[id]);
      }
      refresh();
    }).observe(dialog, { attributes: true, attributeFilter: ["open", "data-pf-stage", "data-pf-internal", "data-mobile-edit"] });
    new MutationObserver(refresh).observe(surface, { attributes: true, attributeFilter: ["aria-busy", "data-selected-image"] });
    mobile.addEventListener("change", () => {
      lastMobile = "";
      field = "";
      refresh();
    });
    return { refresh, setSVG(svg, mm) {
      paper = [900, 900 * mm[1] / mm[0]];
      boxes = {};
      const slots = mapTextSlots(design, mm);
      const source = new DOMParser().parseFromString(svg, "image/svg+xml");
      const glyphs = [...source.querySelectorAll("path[transform]")].map((node) => ({ node, matrix: node.getAttribute("transform").match(/matrix\(([^)]+)\)/)?.[1].trim().split(/[ ,]+/).map(Number) })).filter(({ matrix: m }) => m?.length === 6 && m.every(Number.isFinite) && m[0] > 0 && m[0] < 0.2 && m[0] === m[3] && m[1] === 0 && m[2] === 0);
      const measuring = document.createElementNS(ns, "svg");
      measuring.style.cssText = "position:fixed;left:-10000px;top:0;width:900px;height:1800px;visibility:hidden;pointer-events:none";
      measuring.setAttribute("aria-hidden", "true");
      document.body.append(measuring);
      try {
        for (const [key, s] of Object.entries(slots)) {
          const group = document.createElementNS(ns, "g");
          measuring.append(group);
          for (const { node, matrix: m } of glyphs) if (Math.abs(m[5] - s.y) < 1e-3) {
            const path = document.createElementNS(ns, "path");
            path.setAttribute("d", node.getAttribute("d"));
            path.setAttribute("transform", node.getAttribute("transform"));
            group.append(path);
          }
          const b = group.getBBox(), pad = 12;
          boxes[key] = b.width > 0 ? { x: b.x - pad, y: b.y - pad, width: b.width + 2 * pad, height: b.height + 2 * pad } : { x: s.align === "left" ? s.x : s.x - 90, y: s.y - s.size - pad, width: 180, height: s.size + 2 * pad };
        }
      } finally {
        measuring.remove();
      }
      refresh();
    } };
  }

  // personalisation-product-integration/gift-message.mjs
  function normaliseGift(input) {
    if (input == null || input.enabled === false) return null;
    if (typeof input !== "object" || input.enabled !== true) throw Error("Choose whether to add a gift message.");
    const text = (key, max, label) => {
      if (typeof input[key] !== "string") throw Error(`Enter ${label}.`);
      const value = input[key].normalize("NFC").trim();
      if (!value || value.length > max || /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(value)) throw Error(`Enter ${label} using up to ${max} characters.`);
      return value;
    };
    const recipientName = text("recipientName", 80, "the recipient's name"), fromName = text("fromName", 80, "your name"), message = text("message", 300, "a gift message");
    const recipientEmail = text("recipientEmail", 254, "the recipient's email address");
    if (/[\r\n\t]/.test(recipientName + fromName)) throw Error("Enter names on one line.");
    if (!/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(recipientEmail)) throw Error("Enter a valid recipient email address.");
    return { enabled: true, recipientName, recipientEmail, fromName, message, delivery: "after-confirmed-delivery" };
  }
  function giftOrderProperties(input) {
    const gift = normaliseGift(input);
    return gift ? { "Gift recipient": gift.recipientName, "Gift from": gift.fromName, "Gift message": gift.message, "Gift delivery": "Email after courier-confirmed delivery", _Laboo_Is_Gift: "true", _Laboo_Gift_Recipient_Email: gift.recipientEmail, _Laboo_Gift_Email_Status: "pending_order" } : {};
  }

  // personalisation-product-integration/city-map-pilot/companion-map-art.mjs
  function createCompanionMapArtwork(apiOrigin, design = "monochrome") {
    const configs = /* @__PURE__ */ new Map(), artworks = /* @__PURE__ */ new Map();
    const read = async (response) => {
      if (!response.ok) throw Error("The matching map colours could not load. Please try again.");
      return response;
    };
    return async (city, colourway) => {
      const key = city + "|" + colourway;
      if (!artworks.has(key)) artworks.set(key, (async () => {
        if (!configs.has(city)) configs.set(city, fetch(new URL("/shopify/city-map/city-map-" + design + "-" + city + "-v1/config?country=GB", apiOrigin)).then(read).then((r) => r.json()));
        const config = await configs.get(city), size = config.sizes.find((s) => s.id === "a3") || config.sizes[0];
        const response = await read(await fetch(config.production.api + "/preview", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "omit", body: JSON.stringify({ template: config.production.template, revision: config.production.revision, country: "GB", variantId: size.variantId, finish: "none", fields: config.defaults.fields, location: config.defaults.location, colourway }) }));
        const url = URL.createObjectURL(new Blob([await response.text()], { type: "image/svg+xml" }));
        try {
          const image = await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(Error("A matching map preview could not load."));
            img.src = url;
          });
          const c = document.createElement("canvas");
          c.width = 1e3;
          c.height = Math.round(1e3 * image.naturalHeight / image.naturalWidth);
          c.getContext("2d").drawImage(image, 0, 0, c.width, c.height);
          return c.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, c.width, c.height);
        } finally {
          URL.revokeObjectURL(url);
        }
      })().catch((error) => {
        artworks.delete(key);
        throw error;
      }));
      return artworks.get(key);
    };
  }

  // personalisation-product-integration/swipe-gallery.mjs
  function attachSwipeGallery(surface, onSwipe) {
    let gesture = null, suppressClickUntil = 0;
    const ignored = "[data-gallery-index],[data-gallery-step],input,select,textarea,a,[data-swipe-ignore]";
    surface.style.touchAction = "pan-y pinch-zoom";
    surface.addEventListener("pointerdown", (e) => {
      if (e.isPrimary === false || e.button > 0 || e.target.closest?.(ignored)) return;
      gesture = { id: e.pointerId, x: e.clientX, y: e.clientY, horizontal: false };
    });
    surface.addEventListener("pointermove", (e) => {
      if (!gesture || e.pointerId !== gesture.id) return;
      const x = e.clientX - gesture.x, y = e.clientY - gesture.y;
      if (!gesture.horizontal) {
        if (Math.abs(y) > 12 && Math.abs(y) > Math.abs(x)) {
          gesture = null;
          return;
        }
        if (Math.abs(x) < 12 || Math.abs(x) < Math.abs(y) * 1.2) return;
        gesture.horizontal = true;
        try {
          surface.setPointerCapture(e.pointerId);
        } catch {
        }
      }
      if (e.cancelable) e.preventDefault();
    });
    surface.addEventListener("pointerup", (e) => {
      if (!gesture || e.pointerId !== gesture.id) return;
      const g = gesture;
      gesture = null;
      if (g.horizontal) {
        suppressClickUntil = Date.now() + 500;
        const distance = e.clientX - g.x, threshold = Math.min(70, Math.max(35, surface.clientWidth * 0.12));
        if (Math.abs(distance) >= threshold) onSwipe(distance < 0 ? 1 : -1);
      }
    });
    surface.addEventListener("pointercancel", () => {
      if (gesture?.horizontal) suppressClickUntil = Date.now() + 500;
      gesture = null;
    });
    surface.addEventListener("click", (e) => {
      if (Date.now() < suppressClickUntil) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
    surface.addEventListener("dragstart", (e) => {
      if (!e.target.closest?.(ignored)) e.preventDefault();
    });
  }

  // personalisation-product-integration/gift-message-ui.mjs
  function createGiftMessage(host, { productId, api, onChange = () => {
  }, onAvailability = () => {
  } } = {}) {
    const section = document.createElement("section");
    section.className = "laboo-gift-section";
    section.hidden = true;
    section.innerHTML = '<div data-gift-choice><p class="laboo-gift-packaging-note"><strong>No invoice, receipt or pricing is included in the parcel.</strong></p><label class="laboo-gift-toggle"><input type="checkbox" data-gift-enabled> Add a gift message <small>Optional</small></label><p class="laboo-gift-delivery-note">We\u2019ll email your note to the recipient after the courier confirms delivery.</p></div><div class="laboo-gift-fields" hidden><div data-gift-part="recipientName"><label for="laboo-gift-to">Recipient\u2019s name</label><input id="laboo-gift-to" data-gift="recipientName" maxlength="80" autocomplete="off"></div><div data-gift-part="recipientEmail"><label for="laboo-gift-email">Recipient\u2019s email</label><input id="laboo-gift-email" data-gift="recipientEmail" type="email" maxlength="254" autocomplete="off" inputmode="email"><p>We\u2019ll use this address only to send your gift message after confirmed delivery.</p></div><div data-gift-part="fromName"><label for="laboo-gift-from">From</label><input id="laboo-gift-from" data-gift="fromName" maxlength="80" autocomplete="off"></div><div data-gift-part="message"><label for="laboo-gift-message">Your gift message</label><textarea id="laboo-gift-message" data-gift="message" maxlength="300" rows="3" placeholder="Write a personal note"></textarea><p><span data-gift-count>0</span>/300 characters</p></div></div><p data-gift-error role="status" aria-live="polite"></p>';
    host.append(section);
    const toggle = section.querySelector("[data-gift-enabled]"), fields = section.querySelector(".laboo-gift-fields"), error = section.querySelector("[data-gift-error]");
    let enabled = false;
    const inputs = [...fields.querySelectorAll("[data-gift]")];
    function getGift() {
      return normaliseGift(enabled && toggle.checked ? { enabled: true, ...Object.fromEntries(inputs.map((el) => [el.dataset.gift, el.value])) } : null);
    }
    function validate(field) {
      error.textContent = "";
      for (const el of inputs) el.removeAttribute("aria-invalid");
      if (!enabled || !toggle.checked) return true;
      if (field) {
        const el = inputs.find((el2) => el2.dataset.gift === field), value = el?.value.trim();
        if (value && (field !== "recipientEmail" || /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(value)) && (!["recipientName", "fromName"].includes(field) || !/[\r\n\t]/.test(value))) return true;
        error.textContent = field === "recipientEmail" ? "Enter a valid recipient email address." : "Please complete this field.";
        el?.setAttribute("aria-invalid", "true");
        el?.focus({ preventScroll: true });
        return false;
      }
      try {
        getGift();
        return true;
      } catch (e) {
        error.textContent = e.message;
        const el = inputs.find((el2) => !el2.value.trim() || el2.type === "email" && !el2.validity.valid);
        el?.setAttribute("aria-invalid", "true");
        el?.focus({ preventScroll: true });
        return false;
      }
    }
    function changed() {
      fields.hidden = !toggle.checked;
      section.querySelector("[data-gift-count]").textContent = String(section.querySelector('[data-gift="message"]').value.length);
      error.textContent = "";
      for (const el of inputs) el.removeAttribute("aria-invalid");
      onChange();
    }
    toggle.addEventListener("change", changed);
    fields.addEventListener("input", changed);
    const ready = (async () => {
      try {
        const response = await fetch(new URL("/shopify/gift-config?productId=" + encodeURIComponent(productId), api), { credentials: "omit" });
        if (!response.ok) return false;
        const config = await response.json();
        enabled = config.enabled === true;
        section.hidden = !enabled;
        onAvailability();
        return enabled;
      } catch {
        return false;
      }
    })();
    return { section, choice: section.querySelector("[data-gift-choice]"), fields, inputs, ready, getGift, getGiftKey: () => enabled && toggle.checked ? JSON.stringify(inputs.map((el) => [el.dataset.gift, el.value])) : null, validate, isEnabled: () => enabled, isSelected: () => enabled && toggle.checked };
  }

  // personalisation-product-integration/print-catalogue.mjs
  var PRINT_COUNTRIES = ["AU", "AT", "BE", "BG", "CA", "HR", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "ID", "IE", "IL", "IT", "JP", "LV", "LT", "LU", "MY", "MT", "NL", "NZ", "NO", "PL", "PT", "SA", "SG", "SK", "SI", "KR", "ES", "SE", "CH", "TW", "TH", "TR", "AE", "GB", "US"];
  var PRINT_PRODUCTS = { "210x297": { "metric": { "mm": [210, 297], "productUid": "flat_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [203.2, 304.8], "productUid": "flat_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver" } }, "297x420": { "metric": { "mm": [297, 420], "productUid": "flat_a3_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [304.8, 406.4], "productUid": "flat_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "420x594": { "metric": { "mm": [420, 594], "productUid": "flat_a2_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [406.4, 609.6], "productUid": "flat_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "594x841": { "metric": { "mm": [594, 841], "productUid": "flat_a1_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [609.6, 812.8], "productUid": "flat_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "841x1189": { "metric": { "mm": [841, 1189], "productUid": "flat_a0_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": null }, "130x180": { "metric": { "mm": [130, 180], "productUid": "flat_130x180-mm-5r_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [127, 177.8], "productUid": "flat_5r-130x180-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "270x350": { "metric": { "mm": [270, 350], "productUid": "flat_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [279.4, 355.6], "productUid": "flat_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "300x400": { "metric": { "mm": [300, 400], "productUid": "flat_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [304.8, 406.4], "productUid": "flat_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "400x500": { "metric": { "mm": [400, 500], "productUid": "flat_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [406.4, 508], "productUid": "flat_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "400x600": { "metric": { "mm": [400, 600], "productUid": "flat_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [406.4, 609.6], "productUid": "flat_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "500x700": { "metric": { "mm": [500, 700], "productUid": "flat_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [508, 711.2], "productUid": "flat_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "600x800": { "metric": { "mm": [600, 800], "productUid": "flat_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [609.6, 812.8], "productUid": "flat_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "600x900": { "metric": { "mm": [600, 900], "productUid": "flat_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [609.6, 914.4], "productUid": "flat_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "700x1000": { "metric": { "mm": [700, 1e3], "productUid": "flat_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [711.2, 1016], "productUid": "flat_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver" } }, "750x1000": { "metric": { "mm": [750, 1e3], "productUid": "flat_750x1000-mm-30x40-inch_200-gsm-80lb-uncoated_4-0_ver" }, "northAmerica": { "mm": [762, 1016], "productUid": "flat_30x40-inch-750x1000-mm_200-gsm-80lb-uncoated_4-0_ver" } } };
  function printProduct(variant, country = "GB") {
    if (!PRINT_COUNTRIES.includes(country)) throw Error("DELIVERY_COUNTRY_NOT_SUPPORTED");
    const key = variant.mm.map((n) => n === 595 ? 594 : n).join("x"), entry = PRINT_PRODUCTS[key];
    if (!entry) throw Error("PRINT_SIZE_NOT_MAPPED");
    const product = ["US", "CA"].includes(country) ? entry.northAmerica : entry.metric;
    if (!product) return { available: false, label: "This size is unavailable for this delivery country." };
    const units = country === "US" ? "in" : "cm", divisor = country === "US" ? 25.4 : 10;
    const format = (n) => String(Number((n / divisor).toFixed(2)));
    return { ...product, available: true, country, label: product.mm.map(format).join(" \xD7 ") + " " + units };
  }

  // personalisation-product-integration/selected-size-guide.mjs
  var PERSON_MM = 1778;
  var number = (value) => String(Number(value.toFixed(2)));
  function selectedSize(variantId, country, regionalLabel = "", variants = {}) {
    const variant = variants[variantId];
    if (!variant) return null;
    const us = country === "US", product = printProduct(variant, country);
    if (!product.available) return null;
    const dimensions = product.mm.map((mm) => mm / (us ? 25.4 : 10));
    const [width, height] = dimensions, unit = us ? "in" : "cm", series = !us ? variant.originalTitle.match(/^A[0-4]\b/)?.[0] : null;
    return { label: `${series && !["US", "CA"].includes(country) ? series + " \xB7 " : ""}${number(width)} \xD7 ${number(height)} ${unit}`, widthText: `${number(width)} ${unit}`, heightText: `${number(height)} ${unit}`, mm: product.mm, personLabel: us ? "Person: 5 ft 10 in" : "Person: 178 cm", country, unit };
  }
  function createSelectedSizeGuide(container) {
    container.innerHTML = `<h3>See the size</h3><svg viewBox="0 0 2400 2050" role="img" aria-label="Selected print compared with a person" data-selected-size-guide>
    <title data-guide-title>Selected print size comparison</title>
    <line x1="100" y1="1850" x2="2260" y2="1850" stroke="#d9d5cf" stroke-width="7"/>
    <image href="https://berahgewesjy.shop/cdn/shop/files/Person_Height_ad0db3fc-162d-4483-9f1f-371d99b6bd16.png?v=1770021352&amp;width=200" x="260" y="72" width="482" height="1778" preserveAspectRatio="xMidYMax meet"/>
    <text x="500" y="2000" text-anchor="middle" data-guide-person></text>
    <rect data-guide-frame fill="#262626"/>
    <image data-guide-art preserveAspectRatio="none"/>
    <g stroke="#777" stroke-width="6" fill="none"><path data-guide-width-line/><path data-guide-height-line/></g>
    <text data-guide-width text-anchor="middle"/><text data-guide-height text-anchor="middle"/>
  </svg><p class="laboo-scale-guide-note">Illustrative comparison. Measurements are for the print; frame shown for scale and not included.</p>`;
    const svg = container.querySelector("svg"), get = (name) => container.querySelector(`[data-guide-${name}]`);
    function attrs(el, values) {
      for (const [key, value] of Object.entries(values)) el.setAttribute(key, String(value));
    }
    return {
      update(model, finish) {
        if (!model) return;
        const [width, height] = model.mm, x = 1600 - width / 2, y = 800 - height / 2, edge = 12;
        attrs(get("frame"), { x: x - edge, y: y - edge, width: width + edge * 2, height: height + edge * 2 });
        get("frame").setAttribute("fill", finish === "natural-wood" ? "#c9ad88" : finish === "white" ? "#e7e5e0" : "#262626");
        get("frame").setAttribute("visibility", finish === "none" ? "hidden" : "visible");
        attrs(get("art"), { x, y, width, height });
        get("width-line").setAttribute("d", `M${x} ${y - 70}v-60m0 30h${width}m0-30v60`);
        get("height-line").setAttribute("d", `M${x + width + 70} ${y}h60m-30 0v${height}m-30 0h60`);
        attrs(get("width"), { x: 1600, y: y - 150 });
        get("width").textContent = model.widthText;
        attrs(get("height"), { x: x + width + 210, y: 800, transform: `rotate(90 ${x + width + 210} 800)` });
        get("height").textContent = model.heightText;
        get("person").textContent = model.personLabel;
        const label = `${model.label} print compared with a ${model.personLabel.replace("Person: ", "")} person.${finish === "none" ? " Print only." : " Frame illustrative."}`;
        svg.setAttribute("aria-label", label);
        get("title").textContent = label;
        Object.assign(svg.dataset, { widthMm: String(width), heightMm: String(height), personMm: String(PERSON_MM), units: model.unit });
      },
      setArtwork(url) {
        get("art").setAttribute("href", url);
      }
    };
  }

  // personalisation-product-integration/pdf-proof-renderer.mjs
  var libraryPromise;
  async function within(promise, message) {
    let timer;
    try {
      return await Promise.race([promise, new Promise((_, reject) => {
        timer = setTimeout(() => reject(Error(message)), 3e4);
      })]);
    } finally {
      clearTimeout(timer);
    }
  }
  async function renderSavedProof(saved, { rendererUrl, workerUrl, canvas: canvas2, onProgress = () => {
  } }) {
    if (!rendererUrl || !workerUrl || !saved.printGeometry) throw Error("Please reload the page to prepare the latest proof.");
    onProgress("Loading your saved print file\u2026");
    const response = await fetch(saved.fileUrl, { cache: "no-store", credentials: "omit", signal: AbortSignal.timeout(2e4) });
    if (!response.ok) throw Error("Your saved print file could not be loaded. Please try again.");
    const bytes = new Uint8Array(await response.arrayBuffer());
    const hash = [...new Uint8Array(await crypto.subtle.digest("SHA-256", bytes))].map((n) => n.toString(16).padStart(2, "0")).join("");
    if (hash !== saved.sha256) throw Error("Your saved print file could not be verified. Please prepare it again.");
    onProgress("Opening your final proof\u2026");
    libraryPromise ||= import(rendererUrl).catch((e) => {
      libraryPromise = null;
      throw e;
    });
    const library = await within(libraryPromise, "Your proof viewer took too long to load. Please try again.");
    library.GlobalWorkerOptions.workerSrc = new URL(workerUrl, document.baseURI).href;
    const task = library.getDocument({ data: bytes, isEvalSupported: false, enableXfa: false });
    try {
      onProgress("Preparing your PDF preview\u2026");
      const document2 = await within(task.promise, "Your PDF preview took too long to open. Please try again.");
      if (document2.numPages !== 1) throw Error("Your print file has an unexpected page count.");
      const page = await document2.getPage(1), original = page.getViewport({ scale: 1 }), g = saved.printGeometry;
      if (!(await within(page.getOperatorList(), "Your print file took too long to prepare. Please try again.")).fnArray.length) throw Error("Your print proof has no drawing content. Please try again.");
      if (Math.abs(original.width * 25.4 / 72 - g.fileWidthMm) > 0.02 || Math.abs(original.height * 25.4 / 72 - g.fileHeightMm) > 0.02) throw Error("Your print dimensions could not be verified.");
      const viewport = page.getViewport({ scale: Math.min(2400 / original.width, 3200 / original.height) });
      canvas2.width = Math.ceil(viewport.width);
      canvas2.height = Math.ceil(viewport.height);
      canvas2.hidden = false;
      onProgress("Drawing your final proof\u2026");
      await within(page.render({ canvasContext: canvas2.getContext("2d"), viewport, background: "white" }).promise, "Your print proof took too long to draw. Please try again.");
      const pixels = canvas2.getContext("2d").getImageData(0, 0, canvas2.width, canvas2.height).data;
      let coloured = 0;
      for (let i = 0; i < pixels.length; i += 4 * 97) if (pixels[i] < 240 || pixels[i + 1] < 240 || pixels[i + 2] < 240) coloured++;
      if (coloured < 10) throw Error("Your print proof did not draw correctly. Please try again.");
      return true;
    } finally {
      void task.destroy().catch(() => {
      });
    }
  }

  // personalisation-product-integration/proof-magnifier.mjs
  function magnifierCrop(width, height, displayWidth, displayHeight, x, y, size, zoom = 2) {
    const w = Math.min(width, size / zoom * width / displayWidth), h = Math.min(height, size / zoom * height / displayHeight);
    return { x: Math.max(0, Math.min(width - w, x * width - w / 2)), y: Math.max(0, Math.min(height - h, y * height - h / 2)), width: w, height: h };
  }
  function createProofMagnifier(pane, { nativeMobileZoom = false } = {}) {
    const stage = pane.querySelector(".laboo-final-proof-image"), sheet = pane.querySelector(".laboo-proof-trim-sheet");
    const toolbar = document.createElement("div");
    toolbar.className = "laboo-proof-zoom-tools";
    toolbar.innerHTML = '<button type="button" data-proof-zoom aria-pressed="false" disabled>Zoom details</button><span>Hover to magnify \xB7 On touch screens, turn on zoom and drag.</span>';
    if (nativeMobileZoom) {
      const hint = document.createElement("span");
      hint.className = "laboo-proof-pinch-hint";
      hint.textContent = "Pinch to zoom";
      toolbar.append(hint);
    }
    stage.after(toolbar);
    const lens = document.createElement("div");
    lens.className = "laboo-proof-magnifier";
    lens.hidden = true;
    lens.setAttribute("aria-hidden", "true");
    lens.innerHTML = "<canvas></canvas><span>2\xD7 detail</span>";
    stage.append(lens);
    const marker = document.createElement("div");
    marker.className = "laboo-proof-zoom-marker";
    marker.hidden = true;
    marker.setAttribute("aria-hidden", "true");
    sheet.append(marker);
    const button = toolbar.querySelector("button"), canvas2 = lens.querySelector("canvas");
    button.title = "Turn on zoom, then use the arrow keys or drag across the proof to inspect details.";
    let source = null, active = false, point = { x: 0.5, y: 0.5 }, frame = 0, dragging = false;
    function hide() {
      cancelAnimationFrame(frame);
      frame = 0;
      lens.hidden = true;
      marker.hidden = true;
    }
    function draw() {
      frame = 0;
      if (!source || source.hidden || !source.getClientRects().length) {
        hide();
        return;
      }
      const r = source.getBoundingClientRect(), s = stage.getBoundingClientRect(), size = Math.min(150, s.width - 16, s.height - 16);
      if (size <= 0) return;
      const crop = magnifierCrop(source.width, source.height, r.width, r.height, point.x, point.y, size);
      const dpr = Math.min(window.devicePixelRatio || 1, 2), pixels = Math.round(size * dpr);
      if (canvas2.width !== pixels) {
        canvas2.width = pixels;
        canvas2.height = pixels;
      }
      const context = canvas2.getContext("2d");
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = "high";
      context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, pixels, pixels);
      lens.style.width = lens.style.height = size + "px";
      const px = r.left - s.left + point.x * r.width, py = r.top - s.top + point.y * r.height;
      lens.style.left = Math.max(8, Math.min(s.width - size - 8, px - size / 2)) + "px";
      lens.style.top = Math.max(8, Math.min(s.height - size - 8, py - size - 22 >= 8 ? py - size - 22 : py + 22)) + "px";
      marker.style.left = crop.x / source.width * 100 + "%";
      marker.style.top = crop.y / source.height * 100 + "%";
      marker.style.width = crop.width / source.width * 100 + "%";
      marker.style.height = crop.height / source.height * 100 + "%";
      lens.hidden = marker.hidden = false;
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(draw);
    }
    function move(event) {
      if (!source) return;
      const r = source.getBoundingClientRect();
      point = { x: Math.max(0, Math.min(1, (event.clientX - r.left) / r.width)), y: Math.max(0, Math.min(1, (event.clientY - r.top) / r.height)) };
      schedule();
    }
    function setActive(value) {
      active = value;
      button.setAttribute("aria-pressed", String(active));
      button.textContent = active ? "Close zoom" : "Zoom details";
      sheet.classList.toggle("laboo-proof-zoom-active", active);
      if (active) schedule();
      else hide();
    }
    button.addEventListener("click", () => setActive(!active));
    button.addEventListener("keydown", (event) => {
      const directions = { ArrowLeft: [-0.03, 0], ArrowRight: [0.03, 0], ArrowUp: [0, -0.03], ArrowDown: [0, 0.03] };
      if (event.key === "Escape") {
        setActive(false);
        return;
      }
      if (!directions[event.key]) return;
      event.preventDefault();
      if (!active) setActive(true);
      const [dx, dy] = directions[event.key];
      point = { x: Math.max(0, Math.min(1, point.x + dx)), y: Math.max(0, Math.min(1, point.y + dy)) };
      schedule();
    });
    const nativeZoom = () => nativeMobileZoom && window.matchMedia("(max-width:767px)").matches;
    sheet.addEventListener("pointermove", (event) => {
      if (nativeZoom()) return;
      if (event.pointerType === "mouse" || active && dragging) move(event);
    });
    sheet.addEventListener("pointerdown", (event) => {
      if (nativeZoom() || !active || !source) return;
      dragging = true;
      sheet.setPointerCapture(event.pointerId);
      move(event);
    });
    sheet.addEventListener("pointerup", () => {
      dragging = false;
    });
    sheet.addEventListener("pointercancel", () => {
      dragging = false;
      hide();
    });
    sheet.addEventListener("pointerleave", () => {
      if (!active) hide();
    });
    pane.closest("dialog")?.addEventListener("close", () => setActive(false));
    pane.closest(".laboo-customiser-body")?.addEventListener("scroll", () => {
      hide();
    }, { passive: true });
    window.addEventListener("resize", () => {
      if (nativeZoom()) setActive(false);
      else hide();
    });
    return { setSource(value) {
      hide();
      setActive(false);
      source = value;
      button.disabled = !source;
      if (source) point = { x: 0.5, y: 0.5 };
    } };
  }

  // personalisation-product-integration/final-proof-panel.mjs
  function createFinalProofPanel(pane, { prepareProof, rendererUrl, workerUrl, country = "GB", onChange = () => {
  }, isActive = () => true, personalisationType, mobileApprovalPrompt = false }) {
    pane.classList.add("laboo-final-proof");
    pane.innerHTML = '<figure class="laboo-final-proof-figure"><div class="laboo-final-proof-image" aria-busy="false"><div class="laboo-proof-state" data-proof-state-panel hidden><div role="status" aria-live="polite" aria-atomic="true"><span class="laboo-proof-spinner" data-proof-spinner aria-hidden="true"></span><strong data-proof-state-title></strong><p data-proof-state-note></p></div><button type="button" data-proof-state-retry hidden>Try again</button></div><div class="laboo-proof-trim-sheet"><img data-final-proof-image alt="Your final personalised print proof" hidden><div class="laboo-proof-bleed-mask" aria-hidden="true"></div><div class="laboo-proof-cut-edge" aria-hidden="true"><span class="laboo-proof-crop laboo-proof-crop-tl"></span><span class="laboo-proof-crop laboo-proof-crop-tr"></span><span class="laboo-proof-crop laboo-proof-crop-bl"></span><span class="laboo-proof-crop laboo-proof-crop-br"></span></div><div class="laboo-proof-width" data-proof-width></div><div class="laboo-proof-height"><span data-proof-height></span></div></div></div><figcaption><span class="laboo-proof-cut-key"></span> Dashed line: cut edge \xB7 <span class="laboo-proof-bleed-key"></span> Shaded outer strip: bleed removed when trimmed.<br>Rulers show the finished print size. Guides will not be printed.</figcaption></figure><div class="laboo-final-proof-details"><h2 tabindex="-1">Check your final proof</h2><section class="laboo-proof-product-summary" data-proof-product-summary aria-label="What you\u2019ll receive" hidden><div class="laboo-proof-product-thumb"><img data-proof-product-image width="112" height="140" alt="" decoding="async" hidden><span data-proof-product-image-status>Loading preview\u2026</span></div><div><h3>What you\u2019ll receive</h3><dl><div><dt>Print size</dt><dd data-proof-product-size></dd></div><div><dt>Finish</dt><dd data-proof-product-finish></dd></div></dl><p data-proof-product-inclusions></p></div></section><p class="laboo-step-intro">This preview comes directly from your saved print PDF. The area inside the dashed line is your finished print. Any white areas shown are part of your print.</p><p class="laboo-order-summary"></p><p class="laboo-proof-dimensions" data-proof-dimensions></p><p data-final-proof-status role="status" aria-live="polite"></p><button type="button" data-proof-retry hidden>Try preparing your proof again</button><p class="laboo-proof-pdf-link"><a data-final-proof-pdf target="_blank" rel="noopener" hidden>View the saved print PDF</a></p><label class="laboo-final-proof-consent"><input type="checkbox" data-proof-confirm disabled> <span>I have checked the name, number, size and layout and approve this print.</span></label><p class="laboo-proof-error" data-proof-error role="status" aria-live="polite"></p></div>';
    let image = pane.querySelector("[data-final-proof-image]");
    if (personalisationType === "personalised") pane.querySelector(".laboo-final-proof-consent span").textContent = "I have checked the words, dates, size and layout and approve this print.";
    if (personalisationType === "map") pane.querySelector(".laboo-final-proof-consent span").textContent = "I have checked the map location, words, size, layout and frame colour and approve this print.";
    const consent = pane.querySelector("[data-proof-confirm]"), status = pane.querySelector("[data-final-proof-status]"), error = pane.querySelector("[data-proof-error]"), retry = pane.querySelector("[data-proof-retry]"), pdf = pane.querySelector("[data-final-proof-pdf]");
    const stage = pane.querySelector(".laboo-final-proof-image"), statePanel = pane.querySelector("[data-proof-state-panel]"), stateTitle = pane.querySelector("[data-proof-state-title]"), stateNote = pane.querySelector("[data-proof-state-note]"), spinner = pane.querySelector("[data-proof-spinner]"), stateRetry = pane.querySelector("[data-proof-state-retry]");
    function setProofState(state, message = "") {
      const loading = state === "loading";
      stage.dataset.proofState = state;
      stage.setAttribute("aria-busy", String(loading));
      statePanel.hidden = state !== "loading" && state !== "error";
      spinner.hidden = !loading;
      stateRetry.hidden = state !== "error";
      stateTitle.textContent = loading ? "Preparing your print preview\u2026" : "We couldn\u2019t load your preview.";
      stateNote.textContent = message || (loading ? "This can take a moment. Please keep this window open." : "Please try again.");
    }
    const productSummary = pane.querySelector("[data-proof-product-summary]"), productImage = pane.querySelector("[data-proof-product-image]"), productImageStatus = pane.querySelector("[data-proof-product-image-status]");
    function clearProductSummary() {
      productSummary.hidden = true;
      productImage.onload = productImage.onerror = null;
      productImage.removeAttribute("src");
      productImage.hidden = true;
      productImageStatus.hidden = false;
      productImageStatus.textContent = "Loading preview\u2026";
    }
    function updateProductSummary(result, current) {
      const framed = !!result.finish && result.finish !== "none";
      const finish = framed ? { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" }[result.finish] || result.frameLabel : "Print only";
      pane.querySelector("[data-proof-product-size]").textContent = result.size;
      pane.querySelector("[data-proof-product-finish]").textContent = framed ? finish + " frame" : "Print only";
      pane.querySelector("[data-proof-product-inclusions]").textContent = framed ? "Your artwork is fitted inside the frame with protective Perspex. Arrives assembled and ready to hang." : "Unframed print on matte paper. Frame not included.";
      productSummary.hidden = false;
      productSummary.dataset.finish = result.finish || "none";
      productImage.alt = framed ? "Your personalised artwork in the selected " + finish.toLowerCase() + " frame. Frame included." : "Your personalised unframed print. Frame not included.";
      const url = framed ? result.cartPreviewUrl : result.previewUrl;
      productImage.onload = () => {
        if (current !== version) return;
        productImage.hidden = false;
        productImageStatus.hidden = true;
      };
      productImage.onerror = () => {
        if (current !== version) return;
        productImage.hidden = true;
        productImageStatus.hidden = false;
        productImageStatus.textContent = "Preview unavailable";
      };
      if (url) productImage.src = url;
      else productImageStatus.textContent = "Preview unavailable";
    }
    const magnifier = createProofMagnifier(pane, { nativeMobileZoom: mobileApprovalPrompt });
    const approvalLabel = consent.closest("label");
    error.id = "laboo-final-proof-approval-error";
    consent.setAttribute("aria-describedby", error.id);
    const clearApprovalError = () => {
      approvalLabel.classList.remove("laboo-proof-consent-error");
      consent.removeAttribute("aria-invalid");
      error.textContent = "";
    };
    let saved = null, version = 0, imageReady = false;
    function invalidate() {
      version++;
      clearProductSummary();
      setProofState("idle");
      saved = null;
      imageReady = false;
      pane.querySelector("[data-gift-proof-review]")?.remove();
      magnifier.setSource(null);
      consent.checked = false;
      consent.disabled = true;
      image.hidden = true;
      pdf.hidden = true;
      retry.hidden = true;
      clearApprovalError();
      pane.querySelector(".laboo-proof-trim-sheet").dataset.ready = "false";
      for (const selector of ["[data-proof-width]", "[data-proof-height]", "[data-proof-dimensions]"]) pane.querySelector(selector).textContent = "";
      if (isActive()) status.textContent = "Your design changed. Go back and prepare a new final proof.";
      onChange();
    }
    async function prepare() {
      invalidate();
      const current = version;
      setProofState("loading");
      status.textContent = "Preparing your final print proof\u2026";
      try {
        const result = await prepareProof();
        if (current !== version || !isActive()) {
          if (current === version) setProofState("idle");
          return;
        }
        const description = result.personalisationSummary || `${result.name} / ${result.number}`;
        updateProductSummary(result, current);
        const canvas2 = document.createElement("canvas");
        canvas2.hidden = true;
        canvas2.setAttribute("data-final-proof-image", "");
        canvas2.setAttribute("role", "img");
        canvas2.setAttribute("aria-label", `Final proof: ${description}, ${result.size}`);
        image.replaceWith(canvas2);
        image = canvas2;
        await renderSavedProof(result, { rendererUrl, workerUrl, canvas: canvas2, onProgress: (message) => {
          if (current === version && isActive()) status.textContent = message;
        } });
        if (current !== version || !isActive()) {
          if (current === version) setProofState("idle");
          return;
        }
        saved = result;
        const g = result.printGeometry, b = g.bleedMm, sheet = pane.querySelector(".laboo-proof-trim-sheet");
        for (const [side, value] of Object.entries(b)) sheet.style.setProperty("--proof-" + side, `${100 * value / (side === "top" || side === "bottom" ? g.fileHeightMm : g.fileWidthMm)}%`);
        const format = (mm) => `${Number((mm / (country === "US" ? 25.4 : 10)).toFixed(2))} ${country === "US" ? "in" : "cm"}`;
        pane.querySelector("[data-proof-width]").textContent = format(g.widthMm);
        pane.querySelector("[data-proof-height]").textContent = format(g.heightMm);
        pane.querySelector("[data-proof-dimensions]").textContent = `Finished print: ${format(g.widthMm)} \xD7 ${format(g.heightMm)}. Bleed outside the cut edge: ${b.left} mm left, ${b.right} mm right, ${b.top} mm top and ${b.bottom} mm bottom.`;
        pane.querySelector("[data-gift-proof-review]")?.remove();
        if (result.gift) {
          const review = document.createElement("section");
          review.dataset.giftProofReview = "";
          review.className = "laboo-gift-proof-review";
          const heading = document.createElement("strong");
          heading.textContent = "Your gift message";
          const recipient = document.createElement("p");
          recipient.textContent = "To " + result.gift.recipientName + " \xB7 " + result.gift.recipientEmail;
          const note = document.createElement("p");
          note.style.whiteSpace = "pre-wrap";
          note.textContent = result.gift.message;
          const sender = document.createElement("p");
          sender.textContent = "From " + result.gift.fromName;
          const timing = document.createElement("p");
          timing.textContent = "Emailed after courier-confirmed delivery. Your gift note is separate from the printed artwork.";
          review.append(heading, recipient, note, sender, timing);
          pane.querySelector(".laboo-final-proof-consent").before(review);
        }
        const frame = result.finish && result.finish !== "none";
        pane.querySelector(".laboo-order-summary").textContent = description;
        pane.querySelector(".laboo-final-proof-consent span").textContent = (result.personalisationType || personalisationType) === "personalised" ? frame ? "I have checked the words, dates, size, layout and selected frame and approve this ready-to-hang print." : "I have checked the words, dates, size and layout and approve this print." : result.personalisationType === "map" ? frame ? "I have checked the map location, words, size, layout and frame colour and approve this ready-to-hang print." : "I have checked the map location, words, size and layout and approve this print." : frame ? "I have checked the name, number, size, layout and frame colour and approve this ready-to-hang print." : "I have checked the name, number, size and layout and approve this print.";
        sheet.dataset.ready = "true";
        imageReady = true;
        setProofState("ready");
        magnifier.setSource(canvas2);
        consent.disabled = false;
        status.textContent = frame ? "Check the print PDF and selected frame details, then tick the approval box. The frame covers approximately 4\u20135 mm at each edge." : "Check this saved proof, then tick the approval box to continue.";
        pdf.href = result.fileUrl;
        pdf.hidden = false;
        onChange();
      } catch (e) {
        if (current !== version) return;
        image.hidden = true;
        status.textContent = e.message || "Your proof could not be prepared.";
        setProofState("error", status.textContent);
        retry.hidden = false;
        onChange();
      }
    }
    consent.addEventListener("change", () => {
      clearApprovalError();
      onChange();
    });
    retry.addEventListener("click", prepare);
    stateRetry.addEventListener("click", prepare);
    const approved = () => !!saved && imageReady && consent.checked && !consent.disabled;
    return { prepare, invalidate, isReady: () => !!saved && imageReady && !consent.disabled, isApproved: approved, getProof: () => approved() ? saved : null, validate() {
      if (approved()) return true;
      error.textContent = "Please check your final proof and tick the approval box.";
      if (mobileApprovalPrompt && window.matchMedia("(max-width:767px)").matches) {
        approvalLabel.classList.add("laboo-proof-consent-error");
        consent.setAttribute("aria-invalid", "true");
        consent.focus({ preventScroll: true });
        approvalLabel.scrollIntoView({ block: "center", behavior: window.matchMedia("(prefers-reduced-motion:reduce)").matches ? "instant" : "smooth" });
      } else consent.focus();
      return false;
    } };
  }

  // personalisation-product-integration/frame-regional-catalogue.mjs
  var FRAME_REGIONAL_PRODUCTS = { "metric": [["210x297", "natural-wood", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_natural-wood_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "dark-wood", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_dark-wood_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "black", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_black_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "white", [210, 297], "framed_poster_mounted_210x297mm-8x12-inch_white_wood_w12xt22-mm_plexiglass_a4-8x12-inch_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "natural-wood", [297, 420], "framed_poster_mounted_a3_natural-wood_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "dark-wood", [297, 420], "framed_poster_mounted_a3_dark-wood_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "black", [297, 420], "framed_poster_mounted_a3_black_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "white", [297, 420], "framed_poster_mounted_a3_white_wood_w12xt22-mm_plexiglass_a3_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "natural-wood", [420, 594], "framed_poster_mounted_a2_natural-wood_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "dark-wood", [420, 594], "framed_poster_mounted_a2_dark-wood_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "black", [420, 594], "framed_poster_mounted_a2_black_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "white", [420, 594], "framed_poster_mounted_a2_white_wood_w12xt22-mm_plexiglass_a2_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "natural-wood", [594, 841], "framed_poster_mounted_a1_natural-wood_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "dark-wood", [594, 841], "framed_poster_mounted_a1_dark-wood_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "black", [594, 841], "framed_poster_mounted_a1_black_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "white", [594, 841], "framed_poster_mounted_a1_white_wood_w12xt22-mm_plexiglass_a1_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "natural-wood", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_natural-wood_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "dark-wood", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_dark-wood_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "black", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_black_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "white", [270, 350], "framed_poster_mounted_270x350-mm-11x14-inch_white_wood_w12xt22-mm_plexiglass_270x350-mm-11x14-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "natural-wood", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_natural-wood_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "dark-wood", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_dark-wood_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "black", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_black_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "white", [300, 400], "framed_poster_mounted_300x400-mm-12x16-inch_white_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "natural-wood", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_natural-wood_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "dark-wood", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_dark-wood_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "black", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_black_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "white", [400, 500], "framed_poster_mounted_400x500-mm-16x20-inch_white_wood_w12xt22-mm_plexiglass_400x500-mm-16x20-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "natural-wood", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_natural-wood_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "dark-wood", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_dark-wood_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "black", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_black_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "white", [400, 600], "framed_poster_mounted_400x600-mm-16x24-inch_white_wood_w12xt22-mm_plexiglass_400x600-mm-16x24-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "natural-wood", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_natural-wood_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "dark-wood", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_dark-wood_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "black", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_black_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "white", [500, 700], "framed_poster_mounted_500x700-mm-20x28-inch_white_wood_w12xt22-mm_plexiglass_500x700-mm-20x28-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "natural-wood", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_natural-wood_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "dark-wood", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_dark-wood_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "black", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_black_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "white", [600, 800], "framed_poster_mounted_600x800-mm-24x32-inch_white_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "natural-wood", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_natural-wood_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "dark-wood", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_dark-wood_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "black", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_black_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "white", [600, 900], "framed_poster_mounted_600x900-mm-24x36-inch_white_wood_w12xt22-mm_plexiglass_600x900-mm-24x36-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "natural-wood", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_natural-wood_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "dark-wood", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_dark-wood_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "black", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_black_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "white", [700, 1e3], "framed_poster_mounted_700x1000-mm-28x40-inch_white_wood_w12xt22-mm_plexiglass_700x1000-mm-28x40-inch_200-gsm-80lb-uncoated_4-0_ver"]], "northAmerica": [["210x297", "natural-wood", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_natural-wood_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "dark-wood", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_dark-wood_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "black", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_black_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["210x297", "white", [203.2, 304.8], "framed_poster_mounted_8x12-inch-210x297-mm_white_wood_w12xt22-mm_plexiglass_8x12-inch-a4_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "natural-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_natural-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "dark-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_dark-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "black", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_black_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["297x420", "white", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_white_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "natural-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_natural-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "dark-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_dark-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "black", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_black_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["420x594", "white", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_white_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "natural-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_natural-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "dark-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_dark-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "black", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_black_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["594x841", "white", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_white_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "natural-wood", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_natural-wood_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "dark-wood", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_dark-wood_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "black", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_black_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["270x350", "white", [279.4, 355.6], "framed_poster_mounted_11x14-inch-270x350-mm_white_wood_w12xt22-mm_plexiglass_11x14-inch-270x350-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "natural-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_natural-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "dark-wood", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_dark-wood_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "black", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_black_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["300x400", "white", [304.8, 406.4], "framed_poster_mounted_12x16-inch-300x400-mm_white_wood_w12xt22-mm_plexiglass_12x16-inch-300x400-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "natural-wood", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_natural-wood_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "dark-wood", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_dark-wood_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "black", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_black_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x500", "white", [406.4, 508], "framed_poster_mounted_16x20-inch-400x500-mm_white_wood_w12xt22-mm_plexiglass_16x20-inch-400x500-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "natural-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_natural-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "dark-wood", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_dark-wood_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "black", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_black_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["400x600", "white", [406.4, 609.6], "framed_poster_mounted_16x24-inch-400x600-mm_white_wood_w12xt22-mm_plexiglass_16x24-inch-400x600-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "natural-wood", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_natural-wood_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "dark-wood", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_dark-wood_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "black", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_black_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["500x700", "white", [508, 711.2], "framed_poster_mounted_20x28-inch-500x700-mm_white_wood_w12xt22-mm_plexiglass_20x28-inch-500x700-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "natural-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_natural-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "dark-wood", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_dark-wood_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "black", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_black_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x800", "white", [609.6, 812.8], "framed_poster_mounted_24x32-inch-600x800-mm_white_wood_w12xt22-mm_plexiglass_24x32-inch-600x800-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "natural-wood", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_natural-wood_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "dark-wood", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_dark-wood_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "black", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_black_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["600x900", "white", [609.6, 914.4], "framed_poster_mounted_24x36-inch-600x900-mm_white_wood_w12xt22-mm_plexiglass_24x36-inch-600x900-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "natural-wood", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_natural-wood_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "dark-wood", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_dark-wood_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "black", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_black_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"], ["700x1000", "white", [711.2, 1016], "framed_poster_mounted_28x40-inch-700x1000-mm_white_wood_w12xt22-mm_plexiglass_28x40-inch-700x1000-mm_200-gsm-80lb-uncoated_4-0_ver"]] };
  var FRAME_COUNTRY_AVAILABILITY = { "GB": "111111111111111111111111111111111111111111111111", "US": "111111111111111111111111111111111111111111111111", "CA": "111111111111111111111111111111111111111111111111", "FR": "111111111111111111111111111111111111111111111111", "AU": "111111111111111111111111111111111111111111111111", "AT": "111111111111111111111111111111111111111111111111", "BE": "111111111111111111111111111111111111111111111111", "BG": "111111111111111111111111111111111111111111111111", "HR": "111111111111111111111111111111111111111111111111", "CZ": "111111111111111111111111111111111111111111111111", "DK": "111111111111111111111111111111111111111111111111", "EE": "111111111111111111111111111111111111111111111111", "FI": "111111111111111111111111111111111111111111111111", "DE": "111111111111111111111111111111111111111111111111", "GR": "111111111111111111111111111111111111111111111111", "HU": "111111111111111111111111111111111111111111111111", "ID": "111111111111111111111111111111111111111111111111", "IE": "111111111111111111111111111111111111111111111111", "IL": "111111111111111111111111111111111111111111111111", "IT": "111111111111111111111111111111111111111111111111", "JP": "111111111111111111111111111111111111111111111111", "LV": "111111111111111111111111111111111111111111111111", "LT": "111111111111111111111111111111111111111111111111", "LU": "111111111111111111111111111111111111111111111111", "MY": "111111111111111111111111111111111111111111111111", "MT": "111111111111111111111111111111111111111111111111", "NL": "111111111111111111111111111111111111111111111111", "NZ": "111111111111111111111111111111111111111111111111", "NO": "111111111111111111111111111111111111111111111111", "PL": "111111111111111111111111111111111111111111111111", "PT": "111111111111111111111111111111111111111111111111", "SA": "111111111111111111111111111111111111111111111111", "SG": "111111111111111111111111111111111111111111111111", "SK": "111111111111111111111111111111111111111111111111", "SI": "111111111111111111111111111111111111111111111111", "KR": "111111111111111111111111111111111111111111111111", "ES": "111111111111111111111111111111111111111111111111", "SE": "111111111111111111111111111111111111111111111111", "CH": "111111111111111111111111111111111111111111111111", "TW": "111111111111111111111111111111111111111111111111", "TH": "111111111111111111111111111111111111111111111111", "TR": "111111111111111111111111111111111111111111111111", "AE": "111111111111111111111111111111111111111111111111" };

  // personalisation-product-integration/frame-regional.mjs
  var match = (a, b) => a.length === b.length && a.every((v, i) => Math.abs(v - b[i]) < 0.01);
  function regionalFrameProduct(mm, finish, country = "GB") {
    if (!Array.isArray(mm) || mm.length !== 2) return null;
    const region = ["US", "CA"].includes(country) ? "northAmerica" : "metric", entries = FRAME_REGIONAL_PRODUCTS[region], key = mm.map((n) => n === 595 ? 594 : n).join("x");
    const i = entries.findIndex(([size, colour, dimensions2]) => colour === finish && (size === key || match(dimensions2, mm)));
    if (i < 0 || FRAME_COUNTRY_AVAILABILITY[country]?.[i] !== "1") return null;
    const [sourceSize, , dimensions, productUid] = entries[i];
    return { sourceSize, mm: dimensions, productUid, country, assembly: "ready-to-hang" };
  }

  // personalisation-product-integration/standard-frame-geometry.mjs
  var FRAME_COLOURS = [["natural-wood", "Natural wood"], ["dark-wood", "Dark wood"], ["black", "Black"], ["white", "White"]];
  function frameEligibility(model) {
    if (!Array.isArray(model?.mm) || model.mm.length !== 2 || model.mm.some((n) => !Number.isFinite(n) || n <= 0)) return { eligible: false, reason: "Choose an available print size first." };
    const [w, h] = model.mm;
    if (w <= 130 && h <= 180) return { eligible: false, reason: "Frame not available in this size. Available as a print only." };
    if (w >= 750 || h > 1100) return { eligible: false, reason: "Frame not available in this size. Available as a print only." };
    if (model.country && !FRAME_COLOURS.some(([finish]) => regionalFrameProduct(model.mm, finish, model.country))) return { eligible: false, reason: "Frame not available for this size and delivery country. Your print is supplied unframed." };
    return { eligible: true, reason: "" };
  }

  // personalisation-product-integration/clean-frame-mockup.mjs
  var WOOD_PSD = { size: 1500, box: [331, 156, 1175, 1339] };
  function woodMockupLayout(mm, size = 1500) {
    const [left, top, right, bottom] = WOOD_PSD.box;
    const h = bottom - top, w = h * mm[0] / mm[1], x = (left + right - w) / 2;
    const scale = size / WOOD_PSD.size;
    return {
      x: x * scale,
      y: top * scale,
      w: w * scale,
      h: h * scale,
      sourceX: [0, left, right, 1500],
      sourceY: [0, top, bottom, 1500],
      targetX: [0, x, x + w, 1500].map((n) => n * scale),
      targetY: [0, top, bottom, 1500].map((n) => n * scale)
    };
  }
  function drawWoodOverlay(ctx, image, g) {
    for (let row = 0; row < 3; row++) for (let col = 0; col < 3; col++) {
      const sx = g.sourceX[col], sy = g.sourceY[row], sw = g.sourceX[col + 1] - sx, sh = g.sourceY[row + 1] - sy;
      const dx = g.targetX[col], dy = g.targetY[row], dw = g.targetX[col + 1] - dx, dh = g.targetY[row + 1] - dy;
      ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh);
    }
  }
  function createCleanFrameMockup(canvas2, mockupUrl, { onRender = () => {
  }, frameLabel = "frame not included" } = {}) {
    let version = 0;
    const overlays = /* @__PURE__ */ new Map();
    function overlayFor(finish) {
      if (finish === "none") return Promise.resolve(null);
      const key = finish === "natural-wood" ? "wood" : finish;
      if (!overlays.has(key)) overlays.set(key, new Promise((resolve) => {
        const overlay = new Image();
        overlay.crossOrigin = "anonymous";
        overlay.onload = () => resolve(overlay);
        overlay.onerror = () => resolve(null);
        const src = new URL(mockupUrl, "https://berahgewesjy.shop/");
        if (key !== "wood") {
          src.pathname = src.pathname.replace("laboo-supplied-wood-overlay.webp", `laboo-supplied-${key}-overlay.webp`);
          src.search = "";
        }
        overlay.src = src.href;
      }));
      return overlays.get(key);
    }
    return async function update(url, mm = [300, 400], finish = "natural-wood") {
      const current = ++version;
      canvas2.setAttribute("aria-busy", "true");
      const artwork = new Image();
      await new Promise((resolve, reject) => {
        artwork.onload = resolve;
        artwork.onerror = () => reject(Error("Frame artwork unavailable"));
        artwork.src = url;
      });
      const frame = await overlayFor(finish);
      if (current !== version) return;
      const framed = frameEligibility({ mm }).eligible && frame;
      const ctx = canvas2.getContext("2d"), size = canvas2.width;
      ctx.clearRect(0, 0, size, size);
      ctx.fillStyle = "#f7f1ee";
      ctx.fillRect(0, 0, size, size);
      if (framed) {
        const g = woodMockupLayout(mm, size);
        canvas2.dataset.artworkRect = JSON.stringify([g.x / size, g.y / size, g.w / size, g.h / size]);
        ctx.drawImage(artwork, g.x, g.y, g.w, g.h);
        drawWoodOverlay(ctx, frame, g);
      } else {
        const scale = Math.min(size * 0.8 / mm[0], size * 0.88 / mm[1]), w = mm[0] * scale, h = mm[1] * scale;
        canvas2.dataset.artworkRect = JSON.stringify([(size - w) / 2 / size, (size - h) / 2 / size, w / size, h / size]);
        ctx.save();
        ctx.shadowColor = "#0004";
        ctx.shadowBlur = size * 0.016;
        ctx.shadowOffsetX = -size * 0.013;
        ctx.shadowOffsetY = size * 0.012;
        ctx.drawImage(artwork, (size - w) / 2, (size - h) / 2, w, h);
        ctx.restore();
      }
      const label = { "natural-wood": "natural wood", "dark-wood": "dark wood", black: "black", white: "white" }[finish];
      canvas2.setAttribute("aria-label", framed ? `Your personalised artwork in the supplied ${label} mockup. Framed example; ${frameLabel}.` : "Your personalised unframed print.");
      canvas2.setAttribute("aria-busy", "false");
      onRender();
    };
  }

  // personalisation-product-integration/frame-review-prices.mjs
  var FRAME_REVIEW_UPGRADES = { "210x297": 40, "297x420": 50, "420x594": 80, "594x841": 120, "270x350": 50, "300x400": 50, "400x500": 80, "400x600": 80, "500x700": 90, "600x800": 120, "600x900": 130, "700x1000": 160 };
  function frameReviewPrice(model, printPriceText) {
    if (model?.country !== "GB") return null;
    const match2 = String(printPriceText).trim().match(/^£([\d,]+(?:\.\d{1,2})?)$/);
    const upgrade = FRAME_REVIEW_UPGRADES[model.mm.map((n) => n === 595 ? 594 : n).join("x")];
    if (!match2 || !upgrade) return null;
    const print = Number(match2[1].replaceAll(",", ""));
    return Number.isFinite(print) ? { print, upgrade, total: print + upgrade } : null;
  }

  // personalisation-product-integration/standard-frame-choice.mjs
  function createFramePicture(container, { mockupUrl } = {}) {
    const canvas2 = document.createElement("canvas");
    canvas2.width = 1200;
    canvas2.height = 1200;
    canvas2.className = "laboo-selected-frame-canvas";
    canvas2.setAttribute("role", "img");
    container.replaceChildren(canvas2);
    const draw = createCleanFrameMockup(canvas2, mockupUrl, { frameLabel: "frame optional" });
    let key;
    return { update(model, finish = "none", url) {
      if (!model || !url) return;
      const next = JSON.stringify([url, model.mm, finish]);
      if (next === key) return;
      key = next;
      canvas2.dataset.finish = finish;
      draw(url, model.mm, finish).catch(() => {
        key = null;
        canvas2.setAttribute("aria-label", "The selected finish preview could not load. Please reload the page.");
      });
    } };
  }
  function createStandardFrameChoice(pane, { onChange = () => {
  }, mockupUrl, compact = false, reviewOnly = true, checkoutEnabled = false, getOffer = () => null, initialFinish = "none", currency = "GBP" } = {}) {
    const money = (n) => new Intl.NumberFormat("en-GB", { style: "currency", currency }).format(n);
    pane.classList.add("laboo-frame-step");
    pane.innerHTML = `<div class="laboo-frame-controls">${compact ? "" : '<h2 tabindex="-1">Make it ready to hang</h2><p class="laboo-step-intro">Keep your print unframed, or add a slim wooden frame.</p>'}<fieldset class="laboo-frame-options"><legend>Finish</legend>${[["none", "Print only"], ...FRAME_COLOURS].map(([value, label]) => `<label class="laboo-frame-option"><input type="radio" name="laboo_frame_review" value="${value}"${value === "none" ? " checked" : ""}><span class="laboo-frame-swatch" data-finish="${value}" aria-hidden="true"></span><span><strong>${label}</strong><small data-frame-extra="${value}">${value === "none" ? "No frame" : "Standard slim wood frame"}</small></span></label>`).join("")}</fieldset><p class="laboo-frame-availability" role="status" aria-live="polite"></p><p class="laboo-frame-spec">Slim wooden frame \xB7 Protective acrylic glazing \xB7 Ready to hang</p><div class="laboo-frame-price-summary" aria-live="polite" data-frame-price-summary></div><p class="laboo-frame-review-note"><strong>Draft for review.</strong> Frame prices are proposals. Checkout is disabled in this preview.</p></div><figure class="laboo-frame-review-figure"><div class="laboo-frame-square" data-frame-picture></div><figcaption data-frame-caption></figcaption><p class="laboo-frame-geometry-note">Illustrative standard frame. Approximately 4\u20135 mm of artwork is covered at each edge.</p></figure>`;
    if (!reviewOnly) pane.querySelector(".laboo-frame-review-note").textContent = checkoutEnabled ? "Premium matte paper \xB7 Slim pine frame \xB7 Arrives assembled and ready to hang." : "Frame preview. Framed ordering is not available yet. Choose Print only to order.";
    const details = document.createElement("details");
    details.className = "laboo-frame-inclusions";
    details.innerHTML = "<summary>What\u2019s included with a frame?</summary><ul><li>Your personalised print on smooth, heavyweight 200 gsm matte paper.</li><li>A slim pine frame in your selected finish, with protective clear acrylic glazing (plexiglass).</li><li>The print fitted inside the frame, with backing and a hanging kit included.</li><li>Arrives assembled and ready to hang. Fittings may vary by size and production location.</li></ul><p>Print-only orders are supplied unframed. Framed orders have no separate paper mount.</p>";
    pane.querySelector(".laboo-frame-controls").append(details);
    const figure = pane.querySelector("figure"), caption = figure.querySelector("[data-frame-caption]"), geometry = figure.querySelector(".laboo-frame-geometry-note");
    const spec = pane.querySelector(".laboo-frame-spec"), availability = pane.querySelector(".laboo-frame-availability"), summary = pane.querySelector("[data-frame-price-summary]");
    const picture = createFramePicture(pane.querySelector("[data-frame-picture]"), { mockupUrl });
    let model = null, finish = initialFinish, artwork = null, priceText = "";
    pane.querySelector(`input[value="${initialFinish}"]`).checked = true;
    function render() {
      picture.update(model, finish, artwork);
      caption.textContent = `${model?.label || ""} \xB7 ${finish === "none" ? "Print only" : FRAME_COLOURS.find((c) => c[0] === finish)?.[1] + " standard frame"}`;
      spec.hidden = geometry.hidden = finish === "none";
      const proposal = frameReviewPrice(model, priceText), eligible = frameEligibility(model).eligible;
      if (checkoutEnabled) pane.querySelector(".laboo-frame-review-note").textContent = finish === "none" ? eligible ? "Premium matte paper. Frame not included unless selected above." : "Premium matte paper. This size is supplied unframed." : "Premium matte paper \xB7 Slim pine frame \xB7 Arrives assembled and ready to hang.";
      for (const note of pane.querySelectorAll("[data-frame-extra]")) {
        const offer2 = getOffer(note.dataset.frameExtra);
        note.textContent = note.dataset.frameExtra === "none" ? "No frame" : !eligible ? "Print only at this size" : checkoutEnabled ? offer2 ? `+${money(offer2.upgradePence / 100)} \xB7 Ready to hang` : "Not available for this size or destination" : proposal ? `Preview +${money(proposal.upgrade)}` : "Frame price to be confirmed";
      }
      summary.replaceChildren();
      const line = (label, value, strong = false) => {
        const row = document.createElement("p");
        const name = document.createElement("span"), amount = document.createElement(strong ? "strong" : "span");
        name.textContent = label;
        amount.textContent = value;
        row.append(name, amount);
        summary.append(row);
      };
      line("Print", priceText || "Select a size");
      const offer = getOffer(finish);
      if (finish !== "none" && checkoutEnabled && offer) {
        line("Frame upgrade", "+ " + money(offer.upgradePence / 100));
        line("Print & frame total", money(offer.pricePence / 100), true);
        const note = document.createElement("small");
        note.textContent = model?.country === "GB" ? "Ready to hang \xB7 Free UK delivery." : "Ready to hang \xB7 Delivery calculated at checkout.";
        summary.append(note);
      } else if (finish !== "none" && proposal) {
        line("Frame upgrade (preview)", "+ " + money(proposal.upgrade));
        line("Preview total", money(proposal.total), true);
      } else if (finish !== "none") line("Frame upgrade", "Price to be confirmed");
      else if (model?.country === "GB") {
        const note = document.createElement("small");
        note.textContent = "UK delivery \xA35; free from \xA350.";
        summary.append(note);
      }
    }
    pane.addEventListener("change", (event) => {
      if (event.target.name !== "laboo_frame_review") return;
      finish = event.target.value;
      render();
      onChange();
    });
    return {
      figure,
      getFinish: () => finish,
      update(next, url, nextPrice = "") {
        model = next;
        priceText = nextPrice;
        if (url) artwork = url;
        const eligible = frameEligibility(model);
        for (const radio of pane.querySelectorAll("input")) if (radio.value !== "none") radio.disabled = !eligible.eligible || checkoutEnabled && !getOffer(radio.value);
        if ((!eligible.eligible || checkoutEnabled && !getOffer(finish)) && finish !== "none") {
          finish = "none";
          pane.querySelector('input[value="none"]').checked = true;
          onChange();
        }
        availability.textContent = eligible.reason || (checkoutEnabled && !FRAME_COLOURS.some(([value]) => !!getOffer(value)) ? "Frame not available for this size or destination. Your print is supplied unframed." : "");
        render();
      }
    };
  }

  // personalisation-product-integration/frame-order-policy.mjs
  var printOnlyCheckoutAllowed = (reviewOnly, finish = "none", verifiedFrame = false) => !reviewOnly && (finish === "none" || verifiedFrame === true);

  // personalisation-product-integration/personalised-flow-products.mjs
  var SHARED_PREVIEW_FIRST_PRODUCT_IDS = ["10820651843931", "10820651188571", "10820645192027", "10820644536667", "10820084040027", "10820649845083", "10820649124187", "10820647780699", "10820645781851", "10820654072155", "10820650500443", "10820646502747", "10820648436059", "10820637131099", "10820654661979", "10820647125339", "10820652597595", "10820653318491", "10820655317339", "10820643881307", "10820652040539", "10820651319643", "10820645323099", "10820644634971", "10820084072795", "10820649976155", "10820649320795", "10820647944539", "10820645945691", "10820654203227", "10820650664283", "10820646633819", "10820648599899", "10820637294939", "10820654825819", "10820647223643", "10820652728667", "10820653482331", "10820655448411", "10820644012379", "10820652335451", "10820651647323", "10820645585243", "10820644929883", "10820084203867", "10820650271067", "10820649648475", "10820648206683", "10820646273371", "10820654465371", "10820650893659", "10820646863195", "10820648894811", "10820637622619", "10820655087963", "10820647551323", "10820653056347", "10820653777243", "10820655808859", "10820644340059", "10820652237147", "10820651483483", "10820645454171", "10820644798811", "10820084138331", "10820650139995", "10820649419099", "10820648042843", "10820646175067", "10820654301531", "10820650795355", "10820646797659", "10820648763739", "10820637426011", "10820654956891", "10820647420251", "10820652892507", "10820653580635", "10820655612251", "10820644208987", "10408660042075", "10409289187675", "10409351414107", "10410030203227", "10410039738715", "10410055237979", "10410124083547", "10410165371227", "10410234347867", "10410413490523", "10410423288155", "10410465558875", "10410510549339", "10410515136859", "10410521690459", "10410547315035", "10410613014875", "10410629202267", "10410672292187", "10410717741403", "10410723017051", "10410750181723", "10410771710299", "10412025545051", "10412052382043", "10412074631515", "10412092424539", "10412116148571", "10412143346011", "10412161597787", "10412172280155", "10412182864219", "10412196462939", "10412207309147", "10412679266651", "10412715639131", "10412746178907", "10412797231451", "10412833997147", "10412844482907", "10412856475995", "10412887605595", "10412905627995", "10412928565595", "10414224146779", "10414238826843", "10414248395099", "10414258192731", "10414268088667", "10414280278363", "10414291419483", "10414314520923", "10414325858651", "10414759903579", "10414793490779", "10414815215963", "10414822097243", "10414827602267", "10414832025947", "10414835761499", "10416000893275", "10416124035419", "10416131473755", "10416140452187", "10416149201243", "10416211919195", "10416213819739", "10416217686363", "10416224665947", "10416227975515", "10417618813275", "10417776099675", "10417825120603", "10417857003867", "10417870045531", "10419600523611", "10420071072091", "10420071956827", "10420072284507", "10420074119515", "10420075200859", "10420075626843", "10420076183899", "10420077003099", "10420077756763"];

  // personalisation-product-integration/psd-material-artwork-renderer.mjs
  function psdDetailEligible(key, mm) {
    if (!Array.isArray(mm) || !(mm[0] > 0 && mm[1] > 0)) return false;
    if (mm[0] === mm[1]) return key === "paper-square" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-square$/.test(key);
    return mm[1] > mm[0] ? key === "paper" || /^(frame-(natural-wood|dark-wood|black|white)|pack-(natural-wood|dark-wood|black|white)-portrait)$/.test(key) : key === "paper-landscape" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-landscape$/.test(key);
  }
  function psdDetailInverse(q) {
    const [[x0, y0], [x1, y1], [x2, y2], [x3, y3]] = q, dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3, den = dx1 * dy2 - dx2 * dy1, g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den, a = x1 - x0 + g * x1, b = x3 - x0 + h * x3, c = x0, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3, f = y0;
    return [e - f * h, c * h - b, b * f - c * e, f * g - d, a - c * g, c * d - a * f, d * h - e * g, b * g - a * h, a * e - b * d];
  }
  function compositePsdDetail(source, background, mask, template, warp = null) {
    const { width: w, height: h, data: bg } = background, result = new Uint8ClampedArray(bg), s = source.data, sw = source.width, sh = source.height, m = psdDetailInverse(template.quad.map(([x, y]) => [x * w / template.canvas[0], y * h / template.canvas[1]]));
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const offset = (y * w + x) * 4, alpha = mask.data[offset] / 255 * template.opacity;
      if (alpha === 0) continue;
      const X = x + 0.5, Y = y + 0.5, z = m[6] * X + m[7] * Y + m[8], uv = warp ? psdDetailWarpAt(warp, (x + 0.5) * warp.width / w - 0.5, (y + 0.5) * warp.height / h - 0.5) : [(m[0] * X + m[1] * Y + m[2]) / z, (m[3] * X + m[4] * Y + m[5]) / z], u = Math.max(0, Math.min(1, uv[0])), v = Math.max(0, Math.min(1, uv[1])), px = u * (sw - 1), py = v * (sh - 1), sx = Math.floor(px), sy = Math.floor(py), fx = px - sx, fy = py - sy, p = (sy * sw + sx) * 4, q = (sy * sw + Math.min(sx + 1, sw - 1)) * 4, r = (Math.min(sy + 1, sh - 1) * sw + sx) * 4, t = (Math.min(sy + 1, sh - 1) * sw + Math.min(sx + 1, sw - 1)) * 4, weights = [(1 - fx) * (1 - fy), fx * (1 - fy), (1 - fx) * fy, fx * fy];
      for (let c = 0; c < 3; c++) {
        const ink = s[p + c] * weights[0] + s[q + c] * weights[1] + s[r + c] * weights[2] + s[t + c] * weights[3];
        result[offset + c] = bg[offset + c] * (1 - alpha) + bg[offset + c] * ink / 255 * alpha;
      }
    }
    return result;
  }
  function decodePsdDetailWarp(image) {
    const data = new Float32Array(image.width * image.height * 2);
    for (let i = 0; i < image.width * image.height; i++) {
      const p = i * 4;
      data[i * 2] = (image.data[p] << 4 | image.data[p + 2] >> 4) / 4095;
      data[i * 2 + 1] = (image.data[p + 1] << 4 | image.data[p + 2] & 15) / 4095;
    }
    return { width: image.width, height: image.height, data };
  }
  function psdDetailWarpAt(warp, x, y) {
    x = Math.max(0, Math.min(warp.width - 1, x));
    y = Math.max(0, Math.min(warp.height - 1, y));
    const sx = Math.floor(x), sy = Math.floor(y), fx = x - sx, fy = y - sy, a = (sy * warp.width + sx) * 2, b = (sy * warp.width + Math.min(sx + 1, warp.width - 1)) * 2, c = (Math.min(sy + 1, warp.height - 1) * warp.width + sx) * 2, d = (Math.min(sy + 1, warp.height - 1) * warp.width + Math.min(sx + 1, warp.width - 1)) * 2, w = [(1 - fx) * (1 - fy), fx * (1 - fy), (1 - fx) * fy, fx * fy];
    return [0, 1].map((k) => warp.data[a + k] * w[0] + warp.data[b + k] * w[1] + warp.data[c + k] * w[2] + warp.data[d + k] * w[3]);
  }
  var psdDetailWarpFields = /* @__PURE__ */ new Map();
  function psdDetailWarpField(url) {
    if (!psdDetailWarpFields.has(url)) psdDetailWarpFields.set(url, psdDetailImage(url).then((image) => decodePsdDetailWarp(psdDetailPixels(image, image.naturalWidth, image.naturalHeight))).catch((e) => {
      psdDetailWarpFields.delete(url);
      throw e;
    }));
    return psdDetailWarpFields.get(url);
  }
  var psdDetailImages = /* @__PURE__ */ new Map();
  var psdDetailManifests = /* @__PURE__ */ new Map();
  var psdDetailSources = /* @__PURE__ */ new Map();
  var psdDetailResults = /* @__PURE__ */ new Map();
  function psdDetailRemember(cache, key, value, limit) {
    cache.set(key, value);
    if (cache.size > limit) cache.delete(cache.keys().next().value);
    return value;
  }
  function psdDetailImage(url) {
    if (!psdDetailImages.has(url)) psdDetailRemember(psdDetailImages, url, new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => resolve(image);
      image.onerror = () => reject(Error("The detail image could not load."));
      image.src = url;
    }).catch((e) => {
      psdDetailImages.delete(url);
      throw e;
    }), 20);
    return psdDetailImages.get(url);
  }
  function psdDetailSurface(w, h = w) {
    return Object.assign(document.createElement("canvas"), { width: w, height: h });
  }
  function psdDetailPixels(image, w, h = w) {
    const c = psdDetailSurface(w, h), ctx = c.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(image, 0, 0, w, h);
    return ctx.getImageData(0, 0, w, h);
  }
  function psdDetailManifest(base, mm) {
    const url = new URL(mm[0] === mm[1] ? "laboo-tony-square-psd-20261026.json" : mm[0] > mm[1] ? "laboo-tony-horizontal-psd-20261026-v2.json" : "laboo-tony-portrait-paper-psd-20261025.json", new URL(base, "https://berahgewesjy.shop/")).href;
    if (!psdDetailManifests.has(url)) psdDetailManifests.set(url, fetch(url).then((r) => {
      if (!r.ok) throw Error("The detail template could not load.");
      return r.json();
    }).catch((e) => {
      psdDetailManifests.delete(url);
      throw e;
    }));
    return psdDetailManifests.get(url);
  }
  async function renderPsdDetail({ key, mm, artworkUrl, assetBase, size = 1e3 }) {
    if (!psdDetailEligible(key, mm)) throw Error("This Photoshop template does not match the print orientation.");
    const token = [key, mm.join("x"), artworkUrl, assetBase, size].join("|");
    if (psdDetailResults.has(token)) return psdDetailResults.get(token);
    const job = (async () => {
      const manifest = await psdDetailManifest(assetBase, mm), template = manifest.templates[key];
      if (!template) throw Error("Missing Photoshop template.");
      const base = new URL(template.base, new URL(assetBase, "https://berahgewesjy.shop/")).href, sourceKey = artworkUrl + "|" + mm.join("x");
      if (!psdDetailSources.has(sourceKey)) psdDetailRemember(psdDetailSources, sourceKey, psdDetailImage(artworkUrl).then((img) => psdDetailPixels(img, 1200, Math.round(1200 * mm[1] / mm[0]))), 3);
      const [photo, maskImage, art, warp] = await Promise.all([psdDetailImage(base), psdDetailImage(manifest.masks[template.mask]), psdDetailSources.get(sourceKey), template.warp ? psdDetailWarpField(manifest.warps[template.warp]) : null]), original = psdDetailPixels(photo, size), mask = psdDetailPixels(maskImage, size), c = psdDetailSurface(size), ctx = c.getContext("2d");
      ctx.putImageData(new ImageData(compositePsdDetail(art, original, mask, template, warp), size, size), 0, 0);
      return c.toDataURL("image/webp", 0.94);
    })().catch((e) => {
      psdDetailResults.delete(token);
      throw e;
    });
    return psdDetailRemember(psdDetailResults, token, job, 12);
  }

  // personalisation-product-integration/purchase-material-details.mjs
  var MATERIAL_FINISHES = { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" };
  function purchaseMaterialOrientation(mm) {
    const [width, height] = Array.isArray(mm) ? mm : [];
    return width > 0 && height > 0 ? width > height ? "landscape" : width < height ? "portrait" : "square" : "";
  }
  function purchaseMaterialItems(finish = "none", mm) {
    const orientation = purchaseMaterialOrientation(mm), paper = { key: orientation === "square" ? "paper-square" : orientation === "landscape" ? "paper-landscape" : "paper", title: "200 gsm matte paper", note: "Smooth, heavyweight paper with a non-reflective finish. Paper detail illustration." };
    if (!MATERIAL_FINISHES[finish]) return [paper, { key: "flat-pack", title: "Flat-pack example", note: "Smaller prints are usually sent flat. Packaging is chosen for your print size and destination." }, { key: "tubes", title: "Tubes & triangular boxes", note: "Larger prints use protective tubes or triangular packaging. Packaging can vary by print size and destination." }];
    const label = MATERIAL_FINISHES[finish], items = [paper, { key: "frame-" + finish + (orientation === "square" ? "-square" : orientation === "landscape" ? "-landscape" : ""), title: label + " frame & Perspex", note: "Slim pine frame in " + label.toLowerCase() + " with clear protective Perspex glazing beneath the frame. Your personalised artwork is fitted inside. Frame detail illustration." }, { key: "backing-" + finish, title: "Backing & hanging kit", note: label + " frame, backing fitted and hanging kit included. Arrives assembled and ready to hang. Backing illustration; fittings may vary by size and production location." }];
    if (orientation === "portrait" || orientation === "landscape" || orientation === "square") items.push({ key: "pack-" + finish + "-" + orientation, title: "Packed ready to hang", note: "Your " + orientation + " print is fitted inside a " + label.toLowerCase() + " frame with clear Perspex glazing. Arrives assembled and ready to hang. Packaging illustration; carton and protection can vary by size and destination." });
    return items;
  }
  function purchaseMaterialUrl(base, key, thumbnail = false) {
    if (key === "paper-square" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-square$/.test(key)) return new URL("laboo-tony-square-" + key + "-20261026-" + (thumbnail ? "thumb" : "base") + ".webp", new URL(base, "https://berahgewesjy.shop/")).href;
    if (key === "paper-landscape" || /^(frame|pack)-(natural-wood|dark-wood|black|white)-landscape$/.test(key)) return new URL("laboo-tony-horizontal-" + key + "-20261026-" + (thumbnail ? "thumb" : "base") + ".webp", new URL(base, "https://berahgewesjy.shop/")).href;
    return new URL("laboo-own-detail-" + (key === "paper" ? "paper-hand-v2" : key) + "-20261025" + (thumbnail ? "-thumb" : "") + ".webp", new URL(base, "https://berahgewesjy.shop/")).href;
  }
  function createPurchaseMaterialDetails({ host, dialog, assetBase, getSelection, isVisible }) {
    if (!host || !dialog || !assetBase) return { update() {
    } };
    const rail = document.createElement("section");
    rail.className = "laboo-purchase-materials";
    rail.hidden = true;
    rail.setAttribute("aria-label", "Paper, frame and packaging details");
    host.append(rail);
    const viewer = document.createElement("dialog");
    viewer.className = "laboo-material-viewer";
    viewer.setAttribute("aria-label", "Material and packaging details");
    viewer.innerHTML = '<header><strong data-material-title></strong><button type="button" data-material-close>Close \xD7</button></header><div class="laboo-material-view"><button type="button" data-material-prev aria-label="Previous detail"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button><img data-material-image alt="" decoding="async"><span data-material-loading role="status" aria-live="polite">Loading detail\u2026</span><button type="button" data-material-next aria-label="Next detail"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button></div><p data-material-note></p><p class="laboo-material-counter" data-material-counter></p>';
    dialog.append(viewer);
    const image = viewer.querySelector("[data-material-image]"), loading = viewer.querySelector("[data-material-loading]");
    let items = [], key = "", index = 0, scheduled = false, showVersion = 0;
    const close = () => {
      showVersion++;
      if (viewer.open) viewer.close();
    };
    function detail(item, size) {
      const selection = getSelection() || {}, personalised = !!(psdDetailEligible(item.key, selection.mm) && selection.artworkUrl), url = purchaseMaterialUrl(assetBase, item.key, size === 320);
      if (!personalised) return Promise.resolve({ url, personalised: false });
      return renderPsdDetail({ key: item.key, mm: selection.mm, artworkUrl: selection.artworkUrl, assetBase, size }).then((url2) => ({ url: url2, personalised: true }));
    }
    async function show(next) {
      if (!items.length) return;
      index = (next + items.length) % items.length;
      const item = items[index];
      viewer.querySelector("[data-material-title]").textContent = item.title;
      viewer.querySelector("[data-material-note]").textContent = item.note;
      viewer.querySelector("[data-material-counter]").textContent = index + 1 + " of " + items.length;
      const version = ++showVersion;
      loading.hidden = false;
      loading.textContent = "Preparing your detail\u2026";
      image.hidden = true;
      image.alt = item.title + " \u2014 material detail";
      if (!viewer.open) viewer.showModal();
      try {
        const result = await detail(item, 1e3);
        if (version !== showVersion || !viewer.open) return;
        image.dataset.personalised = String(result.personalised);
        image.onload = () => {
          if (version !== showVersion) return;
          image.hidden = false;
          loading.hidden = true;
        };
        image.onerror = () => {
          if (version !== showVersion) return;
          image.hidden = true;
          loading.hidden = false;
          loading.textContent = "This detail image could not load. Close and try again.";
        };
        image.src = result.url;
      } catch {
        if (version === showVersion) {
          loading.hidden = false;
          loading.textContent = "Your personalised detail could not load. Close and try again.";
        }
      }
    }
    viewer.querySelector("[data-material-close]").addEventListener("click", close);
    viewer.querySelector("[data-material-prev]").addEventListener("click", () => show(index - 1));
    viewer.querySelector("[data-material-next]").addEventListener("click", () => show(index + 1));
    viewer.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        event.stopPropagation();
        show(index + (event.key === "ArrowLeft" ? -1 : 1));
      }
    });
    viewer.addEventListener("cancel", (event) => event.stopPropagation());
    dialog.addEventListener("close", close);
    function update() {
      const visible = !!isVisible();
      rail.hidden = !visible;
      if (host.classList.contains("laboo-has-purchase-materials") !== visible) host.classList.toggle("laboo-has-purchase-materials", visible);
      if (!visible) {
        close();
        return;
      }
      const selection = getSelection() || {}, finish = selection.finish || "none", orientation = purchaseMaterialOrientation(selection.mm), nextKey = [finish, orientation, selection.mm?.join("x"), selection.artworkUrl || ""].join("|");
      if (nextKey === key) return;
      const reopen = viewer.open, active = items[index]?.key;
      key = nextKey;
      showVersion++;
      items = purchaseMaterialItems(finish, selection.mm);
      rail.dataset.finish = finish;
      rail.dataset.orientation = orientation;
      rail.style.setProperty("--laboo-material-count", String(items.length));
      rail.replaceChildren();
      for (const [i, item] of items.entries()) {
        const button = document.createElement("button");
        button.type = "button";
        button.setAttribute("aria-label", "View " + item.title.toLowerCase());
        button.setAttribute("aria-haspopup", "dialog");
        button.dataset.materialKey = item.key;
        const photo = document.createElement("img");
        photo.alt = "";
        photo.loading = "lazy";
        photo.decoding = "async";
        photo.width = 320;
        photo.height = 240;
        photo.src = purchaseMaterialUrl(assetBase, item.key, true);
        const label = document.createElement("span");
        label.textContent = item.title;
        button.append(photo, label);
        button.addEventListener("click", () => show(i));
        rail.append(button);
        if (selection.artworkUrl && psdDetailEligible(item.key, selection.mm)) {
          const ownKey = key;
          setTimeout(() => {
            if (key !== ownKey || !photo.isConnected) return;
            void detail(item, 320).then((result) => {
              if (key === ownKey && photo.isConnected) {
                photo.src = result.url;
                photo.dataset.personalised = String(result.personalised);
              }
            }).catch(() => {
            });
          }, 0);
        }
      }
      if (reopen) void show(Math.max(0, items.findIndex((item) => item.key === active)));
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        update();
      });
    }
    new MutationObserver(schedule).observe(dialog, { subtree: true, attributes: true, attributeFilter: ["src", "data-phase", "data-pf-internal", "data-mobile-edit", "class", "open"] });
    dialog.addEventListener("change", schedule);
    dialog.addEventListener("laboo:finish-change", schedule);
    schedule();
    return { update };
  }

  // personalisation-product-integration/preview-first-pilot.mjs
  var PREVIEW_FIRST_PRODUCTS = new Set(SHARED_PREVIEW_FIRST_PRODUCT_IDS);
  var isPreviewFirstPilot = (root2) => PREVIEW_FIRST_PRODUCTS.has(String(root2?.dataset.productId));
  function setupPreviewFirstPilot({ root: root2, page, form, dialog, body, preview, panes, progress, footer, next, back, showStep, validatePrint, validationMessage, modelFor, sizeSelect, options, getFrameOffer, giftFlow }) {
    if (!isPreviewFirstPilot(root2)) return null;
    back.textContent = "\u2190 Back";
    const map = !!root2.matches("[data-laboo-native-map-fields]"), count = map ? 5 : 4, labels = map ? ["Place", "Design", "Size & finish", "Gift message", "Check"] : ["Name & number", "Size & frame", "Gift message", "Check"];
    dialog.style.setProperty("--laboo-pf-steps", String(count));
    let stage = 1, internal = 1;
    page.classList.add("laboo-preview-first-pilot");
    dialog.classList.add("laboo-preview-first");
    dialog.dataset.pfKind = map ? "map" : "football";
    dialog.classList.toggle("laboo-pf-front-only", root2.dataset.exactRoomFinishes === "false");
    const aside = document.createElement("aside");
    aside.className = "laboo-pf-preview";
    aside.setAttribute("aria-label", "Your personalised print preview");
    form.prepend(aside);
    const frames = panes[1].querySelector(".laboo-frame-step");
    if (frames) {
      aside.append(frames);
      frames.querySelector("legend").textContent = "Frame finish";
    }
    createPurchaseMaterialDetails({ host: aside, dialog, assetBase: root2.dataset.frameTextureUrl, getSelection: () => ({ finish: frames?.querySelector("input:checked")?.value || "none", mm: modelFor(sizeSelect.value)?.mm, artworkUrl: panes[1].querySelector("img")?.src }), isVisible: () => dialog.open && internal === 2 });
    const frameInclusion = document.createElement("p");
    frameInclusion.className = "laboo-pf-frame-inclusion";
    frameInclusion.setAttribute("aria-live", "polite");
    frames?.querySelector("fieldset").after(frameInclusion);
    for (const label of frames?.querySelectorAll(".laboo-frame-option") || []) {
      const price = document.createElement("small");
      price.className = "laboo-pf-mobile-frame-price";
      label.querySelector("strong").after(price);
    }
    const toolbar = document.createElement("div");
    toolbar.className = "laboo-pf-view-toolbar";
    toolbar.setAttribute("role", "group");
    toolbar.setAttribute("aria-label", "Preview view");
    for (const [label, image] of [["Your print", 0], ["In a room", 1]]) {
      if (image === 1 && root2.dataset.exactRoomFinishes === "false") continue;
      const b = document.createElement("button");
      b.type = "button";
      b.textContent = label;
      b.dataset.pfView = String(image);
      b.onclick = () => preview.querySelector(`[data-gallery-index="${image}"]`)?.click();
      toolbar.append(b);
    }
    preview.querySelector("[data-preview-gallery]").append(toolbar);
    const gallery = preview.querySelector("[data-preview-gallery]");
    function paintView() {
      for (const b of toolbar.children) b.setAttribute("aria-pressed", String(b.dataset.pfView === "0" ? gallery.dataset.selectedImage === "1" : gallery.dataset.selectedImage !== "1"));
    }
    new MutationObserver(paintView).observe(gallery, { attributes: true, attributeFilter: ["data-selected-image"] });
    paintView();
    const legend = root2.querySelector("legend"), status = root2.querySelector("[data-editor-status]");
    let placeGroup, designGroup;
    if (map) {
      const titleLabel = root2.querySelector('label[for="map-title"]');
      placeGroup = document.createElement("div");
      designGroup = document.createElement("div");
      placeGroup.className = "laboo-pf-place-fields";
      designGroup.className = "laboo-pf-design-fields";
      let design = false;
      for (const node of [...root2.children]) {
        if (node === titleLabel) design = true;
        if (node === legend || node === status || node.tagName === "SCRIPT") continue;
        (design ? designGroup : placeGroup).append(node);
      }
      const extra = designGroup.querySelector(".native-map-extra"), subtitle = designGroup.querySelector('[data-map-field="subtitle"]'), subtitleLabel = designGroup.querySelector('label[for="map-subtitle"]');
      if (extra && subtitle) extra.querySelector("summary").after(subtitleLabel, subtitle);
      const colours = designGroup.querySelector("[data-map-colours]"), colourLabel = designGroup.querySelector(".native-map-colour-label");
      if (colours) designGroup.prepend(colourLabel, colours);
      root2.append(placeGroup, designGroup, status);
      if (extra) extra.open = true;
    } else {
      legend.textContent = "Their name. Their number.";
    }
    const order = document.createElement("div");
    order.className = "laboo-pf-order";
    order.setAttribute("aria-live", "polite");
    order.innerHTML = "<span></span><strong></strong>";
    footer.prepend(order);
    panes[1].querySelector('label[for="laboo-mobile-size"]').textContent = "Print size";
    const sizeGuide = panes[1].querySelector(".laboo-size-frame-guide");
    if (sizeGuide) {
      sizeGuide.open = true;
      sizeGuide.querySelector(".laboo-scale-guide-note").textContent = "Illustrative comparison. Measurements are for the print; any frame shown is for scale.";
    }
    progress.replaceChildren(...labels.map((label, i) => {
      const li = document.createElement("li"), b = document.createElement("button");
      b.type = "button";
      b.textContent = label;
      b.setAttribute("aria-label", i + 1 + ". " + label);
      b.onclick = () => {
        if (i + 1 < stage) go(i + 1);
      };
      li.append(b);
      return li;
    }));
    function go(value) {
      stage = Math.max(1, Math.min(count, value));
      showStep(map ? stage <= 2 ? 1 : stage - 1 : stage);
    }
    const mobile = window.matchMedia("(max-width:767px)"), tasks = [];
    let mobileIndex = 0, optionalWords = map, mobileCurrentId = map ? "place" : "laboo_name";
    const mobileHeading = document.createElement("div");
    mobileHeading.className = "laboo-pf-mobile-heading";
    mobileHeading.innerHTML = '<strong role="heading" aria-level="2"></strong><span></span>';
    progress.after(mobileHeading);
    function part(parent, nodes) {
      const group = document.createElement("div");
      group.className = "laboo-pf-mobile-part";
      const first = nodes.find(Boolean);
      if (first) first.before(group);
      else parent.append(group);
      for (const n of nodes) if (n) group.append(n);
      return group;
    }
    function task(id, label, phase, value, group, optional = false) {
      const input = group?.querySelector("input:not([type=checkbox]):not([type=radio]):not([type=hidden]),select,textarea");
      if (input?.id) {
        for (const original of group.querySelectorAll("label[for]")) if (original.htmlFor === input.id) original.classList.add("laboo-pf-mobile-label");
      }
      tasks.push({ id, label, phase, value, group, optional });
    }
    if (map) {
      const zoom = placeGroup.querySelector(".native-map-zoom");
      task("place", "Choose your place", 1, 1, part(placeGroup, [...placeGroup.children].filter((n) => n !== zoom)));
      task("area", "Choose the map area", 1, 1, part(placeGroup, [zoom]));
      task("colour", "Choose a map colour", 2, 1, part(designGroup, [designGroup.querySelector(".native-map-colour-label"), designGroup.querySelector("[data-map-colours]")]));
      const title = part(designGroup, [designGroup.querySelector('label[for="map-title"]'), designGroup.querySelector("#map-title")]);
      task("title", "Title on your print", 2, 1, title);
      const extra = designGroup.querySelector(".native-map-extra");
      for (const [field, label] of [["subtitle", "Second line (optional)"], ["message", "Short message (optional)"], ["names", "Names (optional)"], ["date", "Date (optional)"]]) task(field, label, 2, 1, part(extra, [extra.querySelector(`label[for="map-${field}"]`), extra.querySelector(`#map-${field}`)]), true);
    } else {
      for (const [name, label] of [["laboo_name", "Add their name"], ["laboo_number", "Choose their number"]]) {
        const input = root2.querySelector(`[name="${name}"]`), group = [...root2.querySelector(".laboo-original-field-grid").children].find((n) => n.contains(input));
        group.classList.add("laboo-pf-mobile-field");
        task(name, label, 1, 1, group);
      }
    }
    const sizeControls = panes[1].querySelector(".laboo-size-frame-controls");
    const sizeGroup = part(sizeControls, [sizeControls.querySelector('label[for="laboo-mobile-size"]'), sizeSelect, sizeControls.querySelector(".laboo-size-frame-guide")]);
    task("size", "Choose your print size", map ? 3 : 2, 2, sizeGroup);
    task("frame", "Choose your frame", map ? 3 : 2, 2, frames);
    if (giftFlow) {
      task("gift-choice", "Gift message (optional)", map ? 4 : 3, 3, giftFlow.choice);
      for (const [field, label] of [["recipientName", "Who is it for?"], ["recipientEmail", "Their email address"], ["fromName", "Who is it from?"], ["message", "Write your gift message"]]) {
        const group = giftFlow.fields.querySelector(`[data-gift-part="${field}"]`);
        group.classList.add("laboo-pf-mobile-part");
        task("gift-" + field, label, map ? 4 : 3, 3, group);
        tasks.at(-1).giftField = field;
      }
    }
    task("proof", "Check your final proof", map ? 5 : 4, 4, null);
    const visibleTasks = () => tasks.filter((t) => (!t.optional || optionalWords) && (!t.giftField || giftFlow.isSelected()));
    function applyMobile() {
      const list = visibleTasks(), current = list[mobileIndex] || list[0];
      dialog.dataset.mobileEdit = current.id;
      mobileCurrentId = current.id;
      for (const t of tasks) t.group?.classList.toggle("laboo-pf-mobile-active", t === current);
      mobileHeading.querySelector("strong").textContent = current.label;
      mobileHeading.querySelector("span").textContent = `${mobileIndex + 1} / ${list.length}`;
      if (!mobile.matches) return;
      const extra = designGroup?.querySelector(".native-map-extra");
      if (extra) extra.open = true;
      if (frames) {
        if (current.id === "frame") sizeGroup.after(frames);
        else if (internal !== 2) aside.append(frames);
      }
      back.hidden = mobileIndex === 0;
      next.textContent = current.id === "gift-choice" && !giftFlow.isSelected() ? "Continue without a message \u2192" : list[mobileIndex + 1]?.id === "proof" ? "Check final proof \u2192" : list[mobileIndex + 1]?.id === "gift-choice" ? "Gift message \u2192" : list[mobileIndex + 1]?.id === "size" ? "Size & finish \u2192" : list[mobileIndex + 1]?.id === "frame" ? "Choose frame \u2192" : "Next \u2192";
      if (current.id === "title" && !optionalWords) next.textContent = "Choose size \u2192";
    }
    function moveMobile(index) {
      const list = visibleTasks();
      mobileIndex = Math.max(0, Math.min(list.length - 1, index));
      const t = list[mobileIndex];
      stage = t.phase;
      showStep(t.value);
    }
    next.addEventListener("click", (event) => {
      if (!mobile.matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const list = visibleTasks(), current = list[mobileIndex], target = list[mobileIndex + 1];
      if (!target) return;
      if (current.id === "place" && !/^Selected:/.test(root2.querySelector("[data-map-selected-location]").textContent)) {
        status.textContent = "Choose an address, or use the city centre, before continuing.";
        return;
      }
      if (current.id === "title" || current.id === "laboo_name") {
        const input = root2.querySelector(current.id === "title" ? "#map-title" : '[name="laboo_name"]');
        if (!input.value.trim()) {
          status.textContent = current.id === "title" ? "Enter a title for your print." : "Enter the name to print on the shirt.";
          input.focus({ preventScroll: true });
          return;
        }
      }
      if ((target.id === "proof" || !map && current.id === "laboo_number") && !validatePrint?.()) {
        status.textContent = validationMessage;
        return;
      }
      if (target.id === "proof" && !options.some((o) => o.dataset.pVariantId === sizeSelect.value && o.dataset.pAvailable === "true")) {
        status.textContent = "Choose an available print size before continuing.";
        return;
      }
      if (current.giftField && !giftFlow.validate(current.giftField)) return;
      if (target.id === "proof" && !giftFlow?.validate()) return;
      moveMobile(mobileIndex + 1);
    }, true);
    back.addEventListener("click", (event) => {
      if (!mobile.matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      moveMobile(mobileIndex - 1);
    }, true);
    const enlarge = gallery.querySelector(".laboo-gallery-enlarge"), originalEnlarge = enlarge?.textContent;
    function responsive() {
      dialog.classList.remove("laboo-pf-compact", "laboo-pf-keyboard");
      if (enlarge) {
        enlarge.textContent = mobile.matches ? "Full screen" : originalEnlarge;
        enlarge.setAttribute("aria-label", mobile.matches ? "View preview full screen" : "Enlarge preview image");
      }
      if (mobile.matches) {
        const list = visibleTasks();
        mobileIndex = Math.max(0, list.findIndex((t) => t.phase === stage));
        moveMobile(mobileIndex);
      } else {
        const extra = designGroup?.querySelector(".native-map-extra");
        if (extra) extra.open = true;
        showStep(internal);
      }
    }
    mobile.addEventListener("change", responsive);
    next.addEventListener("click", (event) => {
      if (map && internal === 1 && stage === 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!validatePrint?.()) {
          status.textContent = validationMessage;
          return;
        }
        go(2);
      }
    }, true);
    if (map) back.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      go(stage - 1);
    }, true);
    if (enlarge && mobile.matches) {
      enlarge.textContent = "Full screen";
      enlarge.setAttribute("aria-label", "View preview full screen");
    }
    return {
      giftAvailabilityChanged() {
        if (mobile.matches) {
          const list = visibleTasks();
          mobileIndex = Math.max(0, list.findIndex((t) => t.id === mobileCurrentId));
          if (list[mobileIndex].value !== internal) moveMobile(mobileIndex);
          else applyMobile();
        } else if (internal === 3) next.textContent = giftFlow.isSelected() ? "Check final proof \u2192" : "Continue without a message \u2192";
      },
      mountPreview() {
        aside.prepend(preview);
      },
      onStep(value) {
        internal = value;
        if (map) {
          if (value > 1) stage = value + 1;
          else if (stage > 2) stage = 2;
        } else stage = value;
        if (frames) {
          const ordering = value === 2;
          if (ordering) sizeSelect.after(frames);
          else aside.append(frames);
          frames.classList.toggle("laboo-pf-order-frames", ordering);
          frames.querySelector("legend").textContent = ordering ? "Frame" : "Frame finish";
        }
        dialog.dataset.pfStage = String(stage);
        dialog.dataset.pfInternal = String(value);
        aside.hidden = value === 4;
        dialog.classList.toggle("laboo-pf-proof", value === 4);
        dialog.classList.remove("laboo-pf-compact", "laboo-pf-keyboard");
        if (mobile.matches) {
          const t = visibleTasks()[mobileIndex];
          if (t?.value !== value) {
            mobileIndex = Math.max(0, visibleTasks().findIndex((t2) => t2.value === value));
          }
          stage = visibleTasks()[mobileIndex].phase;
        }
        if (map) {
          placeGroup.hidden = stage !== 1;
          designGroup.hidden = stage !== 2;
          legend.textContent = stage === 1 ? "Which place is yours?" : "Make it feel like you.";
        }
        for (const [i, li] of [...progress.children].entries()) {
          li.toggleAttribute("aria-current", i + 1 === stage);
          if (i + 1 === stage) li.setAttribute("aria-current", "step");
          const b = li.querySelector("button");
          b.disabled = i + 1 > stage;
          b.setAttribute("aria-current", i + 1 === stage ? "step" : "false");
        }
        footer.querySelector(".laboo-customiser-step-label").textContent = `Step ${stage} of ${count}`;
        back.hidden = stage === 1;
        if (map && stage === 1) next.textContent = "Choose your design \u2192";
        else if (value === 1) next.textContent = "Choose size & frame \u2192";
        applyMobile();
        panes[value - 1].scrollTop = 0;
        if (dialog.open && !mobile.matches) progress.children[stage - 1].querySelector("button").focus({ preventScroll: true });
      },
      refresh({ model, price, offer, finish }) {
        const label = finish === "none" ? "Print only" : { "natural-wood": "Natural wood", "dark-wood": "Dark wood", black: "Black", white: "White" }[finish];
        frameInclusion.textContent = finish === "none" ? "You will receive an unframed paper print. No frame is included." : "Your print is fitted in a " + label.toLowerCase() + " frame with clear Perspex glazing. Arrives assembled and ready to hang.";
        order.querySelector("span").textContent = (model?.label || "Choose a size") + " \xB7 " + label;
        order.querySelector("strong").textContent = offer ? new Intl.NumberFormat("en-GB", { style: "currency", currency: offer.currency || root2.dataset.currency || "GBP" }).format(offer.pricePence / 100) : price;
        for (const card of frames?.querySelectorAll(".laboo-frame-option") || []) {
          const value = card.querySelector("input").value, upgrade = getFrameOffer?.(sizeSelect.value, value);
          card.querySelector(".laboo-pf-mobile-frame-price").textContent = value === "none" ? "No frame" : upgrade ? "+" + new Intl.NumberFormat("en-GB", { style: "currency", currency: upgrade.currency || root2.dataset.currency || "GBP" }).format(upgrade.upgradePence / 100) : "Unavailable";
        }
        for (const option of sizeSelect.options) {
          const m = modelFor(option.value), node = options.find((o) => o.dataset.pVariantId === option.value), frameOffer = getFrameOffer?.(option.value, finish);
          if (m && node) {
            const amount = frameOffer ? new Intl.NumberFormat("en-GB", { style: "currency", currency: frameOffer.currency || root2.dataset.currency || "GBP" }).format(frameOffer.pricePence / 100) : node.dataset.pPrice;
            option.textContent = m.label + " \xB7 " + amount + (finish !== "none" && !frameOffer ? " \xB7 Print only" : "");
          }
        }
      }
    };
  }

  // personalisation-product-integration/mobile-layout.mjs
  function setupMobileLayout(root2, { validatePrint, prepareProof, onChange = () => {
  }, onOpen = () => {
  }, variants = {}, getFrameOffer = () => null, initialFinish = "none", describePrint, getSizeModel, validationMessage = "Enter a name and shirt number, then wait for your preview.", returnsText, proofType } = {}) {
    const frameOptions = root2.dataset.frameOptions === "true" || root2.dataset.frameReview === "true";
    const framesReview = frameOptions && root2.dataset.launchMode !== "live";
    const frameCheckout = root2.dataset.frameCheckout === "true";
    const hasGiftStep = isPreviewFirstPilot(root2), lastStep = hasGiftStep ? 4 : 3;
    const page = root2.closest("product-page"), form = root2.closest("form"), host = form?.parentElement;
    const info = page?.querySelector(".product-info-col"), preview = page?.querySelector(".laboo-original-preview"), cart = form?.querySelector(".product__cart-functions");
    if (!page || !info || !preview || !cart) return;
    const notes = [preview.querySelector(".laboo-preview-build-note"), preview.querySelector(".laboo-original-example-note")].filter(Boolean);
    const media = window.matchMedia("(max-width:767px)");
    const cover = document.createElement("div");
    cover.className = "laboo-mobile-cover";
    cover.innerHTML = '<button type="button" class="laboo-customiser-launch">Personalise your print</button>';
    const dialog = document.createElement("dialog");
    dialog.className = "laboo-mobile-customiser";
    dialog.setAttribute("aria-label", "Personalise your print");
    if (root2.dataset.frameTextureUrl) dialog.style.setProperty("--laboo-frame-texture", `url("${root2.dataset.frameTextureUrl}")`);
    dialog.innerHTML = '<header class="laboo-customiser-header"><strong>Personalise your print</strong><button type="button" data-customiser-close aria-label="Close personalisation">Close \xD7</button></header>';
    host.append(cover, dialog);
    const desktopCover = document.createElement("div");
    desktopCover.className = "laboo-desktop-cover";
    preview.before(desktopCover);
    const galleryWishlist = page.querySelector(".p-media-col .laboo-product-gallery-wishlist");
    if (galleryWishlist) desktopCover.append(galleryWishlist);
    const galleryHome = document.createComment("Product gallery home");
    desktopCover.before(galleryHome);
    const body = document.createElement("div");
    body.className = "laboo-customiser-body";
    const progress = document.createElement("ol");
    progress.className = "laboo-customiser-progress";
    progress.setAttribute("aria-label", "Personalisation steps");
    progress.innerHTML = frameOptions ? "<li>1 \xB7 Personalise</li><li>2 \xB7 Size &amp; frame</li><li>3 \xB7 Final proof</li>" : "<li>1 \xB7 Personalise</li><li>2 \xB7 Size</li><li>3 \xB7 Final proof</li>";
    body.append(progress);
    const panes = Array.from({ length: lastStep }, (_, i) => {
      const pane = document.createElement("section");
      pane.className = "laboo-customiser-step";
      pane.dataset.step = String(i + 1);
      body.append(pane);
      return pane;
    });
    panes[1].innerHTML = '<h2 tabindex="-1">Choose your print size</h2><p class="laboo-step-intro">Select a size to update your print and price.</p><label for="laboo-mobile-size">Print size</label><select id="laboo-mobile-size" aria-label="Print size"></select><div class="laboo-size-review"><img alt="Your selected print" width="150" height="200"><p data-size-summary></p></div>';
    panes[lastStep - 1].innerHTML = '<p class="laboo-order-summary"></p>';
    if (hasGiftStep) {
      panes[2].classList.add("laboo-gift-step");
      panes[2].innerHTML = '<h2 tabindex="-1">Gift message</h2><p class="laboo-step-intro">Add an optional note for the recipient. We\u2019ll email it after the courier confirms delivery, separately from your printed artwork.</p>';
    }
    const returnsNote = document.createElement("p");
    returnsNote.className = "laboo-personalised-returns";
    returnsNote.textContent = returnsText || "Made just for you. No change-of-mind returns or refunds. Your rights if your item is damaged, faulty or not as described are unaffected. Please check your name, number and size before adding to your basket.";
    panes[lastStep - 1].append(returnsNote);
    const footer = document.createElement("div");
    footer.className = "laboo-customiser-footer";
    footer.innerHTML = '<p class="laboo-customiser-step-label" aria-live="polite"></p><p data-mobile-save-status role="status" aria-live="polite"></p><div class="laboo-customiser-navigation"><button type="button" data-customiser-back>Back</button><button type="button" data-customiser-next>Choose size \u2192</button></div><p class="laboo-customiser-notice">Preview only \xB7 Checkout and gift emails disabled</p>';
    const back = footer.querySelector("[data-customiser-back]"), next = footer.querySelector("[data-customiser-next]"), sizeSelect = panes[1].querySelector("select");
    const options = [...page.querySelectorAll(".p-variants-sidebar-wrap .single-variant")].filter((node) => !node.hidden && Object.hasOwn(variants, node.dataset.pVariantId));
    for (const node of options) {
      const option = document.createElement("option");
      option.value = node.dataset.pVariantId;
      option.textContent = `${node.dataset.pVariantLabel || node.dataset.pVariant} \u2014 ${node.dataset.pPrice}`;
      sizeSelect.append(option);
    }
    const sizeCountry = root2.dataset.country || document.documentElement.dataset.labooCountry || "GB";
    const modelFor = (id) => getSizeModel ? getSizeModel(id) : selectedSize(id, sizeCountry, options.find((node) => node.dataset.pVariantId === id)?.dataset.pVariantLabel || "", variants);
    for (const option of sizeSelect.options) {
      const model = modelFor(option.value), node = options.find((node2) => node2.dataset.pVariantId === option.value);
      if (model) {
        const canFrame = frameEligibility(model).eligible && (!frameCheckout || FRAME_COLOURS.some(([finish]) => !!getFrameOffer(option.value, finish)));
        option.textContent = `${model.label} \u2014 ${node.dataset.pPrice}${node.dataset.pAvailable === "false" ? " \xB7 Unavailable" : frameOptions && !canFrame ? " \xB7 Print only (frame not available)" : ""}`;
      } else {
        option.disabled = true;
        option.textContent = "A0 \xB7 Unavailable for this delivery country";
      }
    }
    const availabilityNote = document.createElement("p");
    availabilityNote.setAttribute("role", "status");
    availabilityNote.hidden = true;
    sizeSelect.after(availabilityNote);
    const available = () => !!modelFor(form.querySelector('[name="id"]')?.value) && options.some((node) => node.dataset.pVariantId === form.querySelector('[name="id"]')?.value && node.dataset.pAvailable === "true");
    const guideContainer = document.createElement("section");
    guideContainer.className = "laboo-selected-scale-guide";
    panes[1].append(guideContainer);
    const scaleGuide = createSelectedSizeGuide(guideContainer);
    let artworkUrl;
    let frameChoice = null;
    if (frameOptions) {
      panes[1].classList.add("laboo-size-frame-step");
      panes[1].querySelector("h2").textContent = "Choose your size & frame";
      panes[1].querySelector(".laboo-step-intro").textContent = "Choose a print size, then keep it unframed or add a slim wooden frame.";
      panes[1].querySelector(".laboo-size-review").hidden = true;
      const controls = document.createElement("div");
      controls.className = "laboo-size-frame-controls";
      while (panes[1].firstChild) controls.append(panes[1].firstChild);
      panes[1].append(controls);
      const host2 = document.createElement("div");
      controls.append(host2);
      frameChoice = createStandardFrameChoice(host2, { compact: true, reviewOnly: framesReview, checkoutEnabled: frameCheckout, initialFinish, currency: root2.dataset.currency || window.Shopify?.currency?.active || "GBP", getOffer: (finish) => getFrameOffer(form.querySelector('[name="id"]')?.value, finish), mockupUrl: root2.dataset.frameTextureUrl, onChange: () => {
        finalProof.invalidate();
        refresh();
        root2.dispatchEvent(new CustomEvent("laboo:finish-change"));
        onChange();
      } });
      panes[1].append(frameChoice.figure);
      const guide = document.createElement("details");
      guide.className = "laboo-size-frame-guide";
      guide.innerHTML = "<summary>See the size beside a person</summary>";
      guide.append(guideContainer);
      controls.append(guide);
    }
    const frameDraft = document.createElement("section");
    frameDraft.className = "laboo-customiser-step laboo-frame-draft-proof";
    frameDraft.hidden = true;
    frameDraft.innerHTML = '<div><h2 tabindex="-1">Review your framed print</h2><p data-frame-draft-summary></p><p>This shows the selected frame around your personalised artwork.</p><p class="laboo-frame-review-note"><strong>Framing preview only.</strong> Pricing, saved frame approval and production are still being connected. This is not an approved production proof.</p><p>Frame appearance and the approximate edge coverage are illustrative.</p></div><div class="laboo-frame-square" data-frame-draft-picture></div>';
    const frameDraftPicture = frameOptions ? createFramePicture(frameDraft.querySelector("[data-frame-draft-picture]"), { mockupUrl: root2.dataset.frameTextureUrl }) : null;
    if (frameOptions) body.append(frameDraft);
    const framePending = document.createElement("button");
    framePending.type = "button";
    framePending.disabled = true;
    framePending.dataset.frameCheckoutPending = "";
    framePending.textContent = "Framing preview \xB7 Checkout disabled";
    framePending.hidden = true;
    footer.querySelector(".laboo-customiser-notice").before(framePending);
    let step = 1, pilot = null;
    const editorStatus = root2.querySelector("[data-editor-status]");
    footer.querySelector(".laboo-customiser-notice").textContent = "Preview only \xB7 Checkout disabled";
    if (root2.dataset.launchMode === "live") footer.querySelector(".laboo-customiser-notice").textContent = "Personalised print \xB7 Frame not included";
    if (framesReview) footer.querySelector(".laboo-customiser-notice").textContent = "Frame design preview \xB7 Checkout disabled";
    const syncStatus = () => {
      footer.querySelector("[data-mobile-save-status]").textContent = step === lastStep ? editorStatus.textContent : "";
    };
    new MutationObserver(syncStatus).observe(editorStatus, { childList: true, characterData: true, subtree: true });
    const getGift = () => giftFlow.getGift();
    function refresh() {
      sizeSelect.value = form.querySelector('[name="id"]')?.value || "";
      const model = modelFor(sizeSelect.value), size = model?.label || "", price = options.find((node) => node.dataset.pVariantId === sizeSelect.value)?.dataset.pPrice || "";
      const description = describePrint ? describePrint() : `${root2.querySelector('[name="laboo_name"]').value.toUpperCase()} / ${root2.querySelector('[name="laboo_number"]').value}`;
      scaleGuide.update(model, frameOptions ? frameChoice.getFinish() : void 0);
      guideContainer.hidden = !model;
      availabilityNote.hidden = available();
      availabilityNote.textContent = available() ? "" : "This size is currently unavailable for your location. You can preview it, but cannot add it to your basket.";
      panes[1].querySelector("[data-size-summary]").textContent = `${size} \xB7 ${price}`;
      frameChoice?.update(model, artworkUrl, price);
      const checkoutOffer = frameCheckout ? getFrameOffer(sizeSelect.value, frameChoice?.getFinish()) : null, cartPrice = cart.querySelector(".addtocart-btn-price");
      if (cartPrice) cartPrice.textContent = " . " + (checkoutOffer ? new Intl.NumberFormat("en-GB", { style: "currency", currency: checkoutOffer.currency || root2.dataset.currency || window.Shopify?.currency?.active || "GBP" }).format(checkoutOffer.pricePence / 100) : price);
      const summary = panes[lastStep - 1].querySelector(".laboo-order-summary");
      if (summary) summary.textContent = `${description} \xB7 ${size} \xB7 ${price}`;
      if (frameOptions) {
        const finish = frameChoice.getFinish();
        frameDraftPicture.update(model, finish, artworkUrl);
        frameDraft.querySelector("[data-frame-draft-summary]").textContent = `${description} \xB7 ${size} \xB7 ${FRAME_COLOURS.find((c) => c[0] === finish)?.[1] || "Print only"}${finish === "none" ? "" : " standard frame"}`;
      }
      if (frameOptions && !framesReview) footer.querySelector(".laboo-customiser-notice").textContent = frameChoice.getFinish() === "none" ? "Print only \xB7 Frame not included" : frameCheckout ? "Print & frame \xB7 Assembled and ready to hang \xB7 " + (sizeCountry === "GB" ? "Free UK delivery" : "Delivery calculated at checkout") : "Frame preview \xB7 Ordering not yet available";
      pilot?.refresh({ model, price, offer: checkoutOffer, finish: frameChoice?.getFinish() || "none" });
    }
    function showStep(value) {
      step = value;
      panes.forEach((pane, i) => pane.hidden = i !== step - 1);
      [...progress.children].forEach((li, i) => {
        if (i === step - 1) li.setAttribute("aria-current", "step");
        else li.removeAttribute("aria-current");
      });
      footer.querySelector(".laboo-customiser-step-label").textContent = `Step ${step} of ${lastStep}`;
      back.hidden = step === 1;
      next.hidden = step === lastStep;
      cart.hidden = step !== lastStep;
      next.textContent = step === 1 ? frameOptions ? "Choose size & frame \u2192" : "Choose size \u2192" : hasGiftStep && step === 2 ? "Gift message \u2192" : hasGiftStep && step === 3 && !giftFlow.isSelected() ? "Continue without a message \u2192" : "Check final proof \u2192";
      refresh();
      const framed = frameOptions && step === lastStep && frameChoice.getFinish() !== "none" && !frameCheckout;
      frameDraft.hidden = !framed;
      framePending.hidden = !framed;
      if (framed) {
        panes[lastStep - 1].hidden = true;
        cart.hidden = true;
      }
      syncStatus();
      body.scrollTop = 0;
      if (step === lastStep && !framed) finalProof.prepare();
      else finalProof.invalidate();
      onChange();
      if (dialog.open && !pilot) ((framed ? frameDraft : panes[step - 1]).querySelector("h2,input") || panes[step - 1]).focus({ preventScroll: true });
      pilot?.onStep(step);
    }
    function open() {
      if (!available()) options.find((node) => node.dataset.pAvailable === "true" && modelFor(node.dataset.pVariantId))?.click();
      if (pilot) pilot.mountPreview();
      else panes[0].append(preview);
      dialog.showModal();
      showStep(step);
      onOpen();
    }
    cover.querySelector(".laboo-customiser-launch").addEventListener("click", open);
    dialog.addEventListener("close", () => {
      desktopCover.append(preview);
      onOpen();
    });
    dialog.querySelector("[data-customiser-close]").addEventListener("click", () => dialog.close());
    back.addEventListener("click", () => showStep(Math.max(1, step - 1)));
    function advance() {
      if (step === 2 && !available()) {
        availabilityNote.hidden = false;
        sizeSelect.focus();
        return;
      }
      if (step === 2 && !validatePrint?.()) {
        availabilityNote.hidden = false;
        availabilityNote.textContent = "Please wait for your updated size preview, then continue.";
        return;
      }
      if (step === 1 && !validatePrint?.()) {
        root2.querySelector("[data-editor-status]").textContent = validationMessage;
        return;
      }
      if (step === lastStep - 1 && !giftFlow.validate()) return;
      showStep(Math.min(lastStep, step + 1));
    }
    next.addEventListener("click", advance);
    sizeSelect.addEventListener("change", () => {
      options.find((node) => node.dataset.pVariantId === sizeSelect.value)?.click();
      refresh();
      onChange();
    });
    const giftFlow = createGiftMessage(hasGiftStep ? panes[2] : panes[1].querySelector(".laboo-size-frame-controls") || panes[1], { productId: root2.dataset.productId, api: root2.dataset.api || "https://laboo-personalisation-checkout-pilot.laboo-api.workers.dev", onChange: () => {
      finalProof.invalidate();
      pilot?.giftAvailabilityChanged();
      onChange();
    }, onAvailability: () => {
      pilot?.giftAvailabilityChanged();
    } });
    if (hasGiftStep) giftFlow.ready.then((enabled) => {
      if (!enabled) panes[2].querySelector(".laboo-step-intro").textContent = "Gift messages are temporarily unavailable. Continue to check your print without a message.";
    });
    const finalProof = createFinalProofPanel(panes[lastStep - 1], { prepareProof, onChange, isActive: () => step === lastStep && (!frameChoice || frameChoice.getFinish() === "none" || frameCheckout), country: sizeCountry, rendererUrl: root2.dataset.pdfRendererUrl, workerUrl: root2.dataset.pdfWorkerUrl, personalisationType: proofType, mobileApprovalPrompt: isPreviewFirstPilot(root2) });
    panes[lastStep - 1].querySelector(".laboo-final-proof-details").append(returnsNote);
    page.classList.add("laboo-step-layout");
    panes[0].append(root2);
    desktopCover.append(preview);
    footer.querySelector(".laboo-customiser-navigation").after(cart);
    form.append(body, footer);
    dialog.append(form);
    for (const note of notes) note.hidden = true;
    pilot = setupPreviewFirstPilot({ root: root2, page, form, dialog, body, preview, panes, progress, footer, next, back, showStep, validatePrint, validationMessage, modelFor, sizeSelect, options, getFrameOffer, giftFlow });
    function apply() {
      page.classList.toggle("laboo-mobile-layout", media.matches);
      if (media.matches) cover.prepend(desktopCover);
      else galleryHome.after(desktopCover);
    }
    apply();
    media.addEventListener("change", apply);
    showStep(step);
    return {
      getSelection() {
        const finish = frameChoice?.getFinish() || "none", offer = getFrameOffer(form.querySelector('[name="id"]')?.value, finish);
        return frameCheckout && offer ? { finish, purchaseVariantId: offer.purchaseVariantId } : {};
      },
      getGift,
      getGiftKey: () => giftFlow.getGiftKey(),
      getProof: () => finalProof.getProof(),
      invalidateProof: () => finalProof.invalidate(),
      // On mobile a ready proof keeps Add to Cart actionable. beforeSubmit still
      // requires explicit approval before any approval request or cart mutation.
      canSubmit: () => printOnlyCheckoutAllowed(framesReview, frameChoice?.getFinish(), frameCheckout && !!getFrameOffer(form.querySelector('[name="id"]')?.value, frameChoice?.getFinish())) && step === lastStep && available() && (pilot && media.matches ? finalProof.isReady() : finalProof.isApproved()),
      beforeSubmit() {
        if (!printOnlyCheckoutAllowed(framesReview, frameChoice?.getFinish(), frameCheckout && !!getFrameOffer(form.querySelector('[name="id"]')?.value, frameChoice?.getFinish()))) {
          editorStatus.textContent = "This frame is not available for checkout. Please choose Print only.";
          return false;
        }
        if (step !== lastStep) {
          advance();
          return false;
        }
        if (!available()) {
          editorStatus.textContent = "This size is currently unavailable for your location. Please choose another size.";
          return false;
        }
        return finalProof.validate();
      },
      setPreview(url, alt) {
        artworkUrl = url;
        panes[1].querySelector("img").src = url;
        scaleGuide.setArtwork(url);
        refresh();
      }
    };
  }

  // personalisation-product-integration/frame-preview-choices.mjs
  function createFramePreviewChoices(host, { onChange = () => {
  }, followPurchase = false } = {}) {
    host.classList.add("laboo-frame-preview-controls");
    const label = document.createElement("p");
    label.className = "laboo-frame-preview-label";
    label.textContent = "Preview frame colour";
    const choices = document.createElement("div");
    choices.className = "laboo-frame-preview-colours";
    choices.setAttribute("role", "group");
    choices.setAttribute("aria-label", "Preview frame colour");
    const note = document.createElement("p");
    note.className = "laboo-frame-preview-note";
    note.setAttribute("role", "status");
    const buttons = /* @__PURE__ */ new Map();
    let finish = "natural-wood", lastPurchaseFinish = "none", allowed = [];
    for (const [value, name] of FRAME_COLOURS) {
      const button = document.createElement("button");
      button.type = "button";
      button.dataset.finish = value;
      button.setAttribute("aria-label", "Preview " + name.toLowerCase() + " frame");
      const icon = document.createElement("span");
      icon.className = "laboo-frame-preview-swatch";
      icon.dataset.finish = value;
      icon.setAttribute("aria-hidden", "true");
      const text = document.createElement("span");
      text.textContent = name;
      button.append(icon, text);
      button.onclick = () => {
        if (button.disabled) return;
        finish = value;
        paint();
        onChange(finish);
      };
      buttons.set(value, button);
      choices.append(button);
    }
    function paint() {
      for (const [value, button] of buttons) button.setAttribute("aria-pressed", String(value === finish && allowed.includes(value)));
    }
    host.append(label, choices, note);
    return {
      getFinish: () => allowed.includes(finish) ? finish : "none",
      update(model, { getOffer = () => true, requireOffer = false, purchaseFinish = "none", visible = true } = {}) {
        const eligibility = frameEligibility(model);
        allowed = eligibility.eligible ? FRAME_COLOURS.map((c) => c[0]).filter((f) => !requireOffer || !!getOffer(f)) : [];
        if (purchaseFinish !== lastPurchaseFinish && allowed.includes(purchaseFinish)) finish = purchaseFinish;
        lastPurchaseFinish = purchaseFinish;
        if (!allowed.includes(finish)) finish = allowed[0] || "none";
        if (followPurchase) finish = purchaseFinish === "none" || allowed.includes(purchaseFinish) ? purchaseFinish : "none";
        host.hidden = !visible;
        label.hidden = choices.hidden = allowed.length === 0;
        note.textContent = allowed.length ? "Preview colours here. Choose your order\u2019s finish in Size & frame." : eligibility.reason || "Frame not available for this size or destination. Your print is supplied unframed.";
        note.dataset.available = String(allowed.length > 0);
        for (const [value, button] of buttons) {
          button.disabled = !allowed.includes(value);
          button.title = button.disabled ? "This frame finish is currently unavailable." : "";
        }
        paint();
        return { available: allowed.length > 0, finish: this.getFinish(), reason: allowed.length ? "" : note.textContent };
      }
    };
  }

  // personalisation-product-integration/paper-projection.mjs
  function inverseProjection(quad) {
    const [[x0, y0], [x1, y1], [x2, y2], [x3, y3]] = quad;
    const dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
    const den = dx1 * dy2 - dx2 * dy1, g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den;
    const a = x1 - x0 + g * x1, b = x3 - x0 + h * x3, c = x0, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3, f = y0;
    return [e - f * h, c * h - b, b * f - c * e, f * g - d, a - c * g, c * d - a * f, d * h - e * g, b * g - a * h, a * e - b * d];
  }
  function compositePaper(source, background, quad, options = {}) {
    const { width, height, data } = background, result = new Uint8ClampedArray(data), s = source.data, sw = source.width, sh = source.height;
    const m = inverseProjection(quad), minX = Math.max(0, Math.floor(Math.min(...quad.map((p) => p[0])))), maxX = Math.min(width - 1, Math.ceil(Math.max(...quad.map((p) => p[0])))), minY = Math.max(0, Math.floor(Math.min(...quad.map((p) => p[1])))), maxY = Math.min(height - 1, Math.ceil(Math.max(...quad.map((p) => p[1]))));
    const paperW = Math.hypot(quad[1][0] - quad[0][0], quad[1][1] - quad[0][1]), paperH = Math.hypot(quad[3][0] - quad[0][0], quad[3][1] - quad[0][1]);
    for (let y = minY; y <= maxY; y++) for (let x = minX; x <= maxX; x++) {
      const X = x + 0.5, Y = y + 0.5, z = m[6] * X + m[7] * Y + m[8], u = (m[0] * X + m[1] * Y + m[2]) / z, v = (m[3] * X + m[4] * Y + m[5]) / z;
      if (u < 0 || u > 1 || v < 0 || v > 1) continue;
      const px = u * (sw - 1), py = v * (sh - 1), sx = Math.floor(px), sy = Math.floor(py), fx = px - sx, fy = py - sy;
      const p = (sy * sw + sx) * 4, q = (sy * sw + Math.min(sx + 1, sw - 1)) * 4, r = (Math.min(sy + 1, sh - 1) * sw + sx) * 4, t = (Math.min(sy + 1, sh - 1) * sw + Math.min(sx + 1, sw - 1)) * 4;
      const w0 = (1 - fx) * (1 - fy), w1 = fx * (1 - fy), w2 = (1 - fx) * fy, w3 = fx * fy;
      const coverage = Math.min(1, u * paperW + 0.5, (1 - u) * paperW + 0.5, v * paperH + 0.5, (1 - v) * paperH + 0.5), alpha = coverage * (s[p + 3] * w0 + s[q + 3] * w1 + s[r + 3] * w2 + s[t + 3] * w3) / 255, offset = (y * width + x) * 4;
      let glaze = 0;
      if (options.glazing) {
        const g = options.glazing, gx = Math.round(u * (g.width - 1)), gy = Math.round(v * (g.height - 1));
        glaze = g.data[(gy * g.width + gx) * 4 + 3] / 255;
      }
      const reflection = Math.min(0.4, glaze + (options.reflection ? options.reflection * Math.max(0, 1 - u / 0.38) : 0));
      for (let c = 0; c < 3; c++) {
        const ink = s[p + c] * w0 + s[q + c] * w1 + s[r + c] * w2 + s[t + c] * w3;
        const tint = options.tint?.[c] ?? 255;
        let foreground = options.replace ? ink * tint / 255 * (1 - reflection) + 255 * reflection : data[offset + c] * ink / 255;
        if (options.reflectionPlate) {
          const plate = options.reflectionPlate, gx = Math.round(u * (plate.width - 1)), gy = Math.round(v * (plate.height - 1)), value = plate.data[(gy * plate.width + gx) * 4 + c], base = plate.base?.[c] ?? 128;
          const strength = plate.strength ?? 1, light = Math.min(plate.maxLight ?? 1, Math.max(0, (value - base) / (255 - base)) * strength), dark = Math.min(plate.maxDark ?? 1, Math.max(0, (base - value) / base) * strength);
          foreground = value >= base ? foreground + (255 - foreground) * light : foreground * (1 - dark);
        }
        result[offset + c] = data[offset + c] * (1 - alpha) + alpha * foreground;
      }
    }
    return result;
  }

  // personalisation-product-integration/city-map-pilot/live-map-gallery.mjs
  var load = (url) => new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(Error("This room preview could not load. Please try again."));
    img.src = url;
  });
  var canvas = (w, h = w) => Object.assign(document.createElement("canvas"), { width: w, height: h });
  function fittedQuad(scene, ratio) {
    const factor = ratio / scene.referenceRatio, q = scene.corners.map((p) => [...p]);
    for (const [a, b] of [[0, 1], [3, 2]]) {
      const centre2 = [(q[a][0] + q[b][0]) / 2, (q[a][1] + q[b][1]) / 2];
      for (const i of [a, b]) q[i] = [centre2[0] + (q[i][0] - centre2[0]) * factor, centre2[1] + (q[i][1] - centre2[1]) * factor];
    }
    const centre = [q.reduce((n, p) => n + p[0], 0) / 4, q.reduce((n, p) => n + p[1], 0) / 4];
    return q.map((p) => [centre[0] + (p[0] - centre[0]) * 1.045, centre[1] + (p[1] - centre[1]) * 1.045]);
  }
  function createLiveMapGallery({ surface, output, thumbs, assetBase, frameUrl, frameDetailsUrl, onSelect = () => {
  }, thumbnailClass = "map-gallery-thumb", extraScenes = [], roomManifest = null, glazingBase = null, getCompanionArt = null, onRender = () => {
  }, deferThumbnails = () => false }) {
    let scenePromise;
    const legacyScenes = () => scenePromise ??= fetch(new URL("map-room-scenes.json", assetBase)).then((r) => {
      if (!r.ok) throw Error("Room previews are unavailable.");
      return r.json();
    });
    const images = /* @__PURE__ */ new Map(), glazingData = /* @__PURE__ */ new Map(), front = canvas(1500), roomFrame = canvas(1500), frame = createCleanFrameMockup(front, frameUrl), exampleFrame = createCleanFrameMockup(roomFrame, frameUrl), thumbCanvases = [], labels = ["Your print", "Bedroom", "Hallway", "Statement corner", "Reading corner", "Print only", "Frame finishes", ...extraScenes.map((s) => s.label)];
    const custom = [1, 2].includes(roomManifest?.version) && roomManifest.finishes, roomLabels = ["Bedroom", "Living room", "Entryway", "Hallway collection", "Leaning print", "Travel collection"], paperIndex = custom ? 7 : 5, detailsIndex = paperIndex + 1, extraIndex = paperIndex + 2;
    if (custom) labels.splice(0, labels.length, "Your print", ...roomLabels, "Print only", "Frame finishes", ...extraScenes.map((s) => s.label));
    let index = 0, version = 0, context, prepared, key = "", thumbVersion = 0, thumbnailKey = "";
    const cached = (url) => {
      const s = String(url);
      if (!images.has(s)) images.set(s, load(s).catch((e) => {
        images.delete(s);
        throw e;
      }));
      return images.get(s);
    };
    function framedCrop(source, mm) {
      const g = woodMockupLayout(mm), pad = 23, x = Math.floor(g.x - pad), y = Math.floor(g.y - pad), w = Math.ceil(g.w + pad * 2), h = Math.ceil(g.h + pad * 2), out = canvas(w, h);
      out.getContext("2d").drawImage(source, x, y, w, h, 0, 0, w, h);
      return out;
    }
    function cover(ctx, img, size) {
      const scale = Math.max(size / img.naturalWidth, size / img.naturalHeight), w = img.naturalWidth * scale, h = img.naturalHeight * scale;
      ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);
    }
    async function paint(target, n, p, size = 1200) {
      target.width = size;
      target.height = size;
      const ctx = target.getContext("2d", { willReadFrequently: true });
      ctx.fillStyle = "#f7f1ee";
      ctx.fillRect(0, 0, size, size);
      if (n >= extraIndex) {
        cover(ctx, await cached(extraScenes[n - extraIndex].url), size);
        return;
      }
      if (custom && n >= 1 && n <= 6) {
        const scene = (custom[p.finish] || custom["natural-wood"])[n - 1], photo = await cached(scene.url);
        cover(ctx, photo, size);
        const frames = scene.frames?.length ? scene.frames : [{ ...scene, city: roomManifest.city }], sources = await Promise.all(frames.map((f, i) => i === 0 ? p.artData : getCompanionArt(f.city, p.colourway)));
        for (let i = 0; i < frames.length; i++) {
          const f = frames[i], source = sources[i], maskUrl = String(f.glazingUrl || new URL(f.glazingAsset, new URL(glazingBase, document.baseURI)));
          if (!glazingData.has(maskUrl)) glazingData.set(maskUrl, cached(maskUrl).then((mask) => {
            const g = canvas(mask.naturalWidth, mask.naturalHeight);
            g.getContext("2d").drawImage(mask, 0, 0);
            return g.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, g.width, g.height);
          }).catch((e) => {
            glazingData.delete(maskUrl);
            throw e;
          }));
          const glazing = await glazingData.get(maskUrl), result = compositePaper(source, ctx.getImageData(0, 0, size, size), f.paperQuad.map((p2) => p2.map((v) => v * size / scene.width)), { replace: true, ...f.reflectionBase ? { reflectionPlate: { width: glazing.width, height: glazing.height, data: glazing.data, base: f.reflectionBase, strength: f.reflectionStrength ?? 0.8, maxLight: f.maxLight ?? 0.34, maxDark: f.maxDark ?? 0.12 } } : { glazing }, tint: [250, 249, 246] });
          ctx.putImageData(new ImageData(result, size, size), 0, 0);
        }
        return;
      }
      if (n === 0) {
        ctx.drawImage(p.front, 0, 0, size, size);
        return;
      }
      if (n >= 1 && n <= 4) {
        const data = await legacyScenes(), scene = data.scenes[n - 1], photo = await cached(new URL(scene.file, assetBase));
        cover(ctx, photo, size);
        const source = p.framed.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, p.framed.width, p.framed.height), background = ctx.getImageData(0, 0, size, size), quad = fittedQuad(scene, p.mm[0] / p.mm[1]).map((v) => v.map((x) => x * size / 1200));
        ctx.putImageData(new ImageData(compositePaper(source, background, quad, { replace: true, reflection: 0.012 }), size, size), 0, 0);
        return;
      }
      if (n === paperIndex) {
        const scale = Math.min(size * 0.76 / p.mm[0], size * 0.84 / p.mm[1]), w = p.mm[0] * scale, h = p.mm[1] * scale;
        ctx.save();
        ctx.shadowColor = "#0003";
        ctx.shadowBlur = size * 0.02;
        ctx.shadowOffsetY = size * 0.012;
        ctx.drawImage(p.art, (size - w) / 2, (size - h) / 2, w, h);
        ctx.restore();
        return;
      }
      const details = await cached(frameDetailsUrl || new URL("map-frame-details-v1.webp", assetBase));
      ctx.drawImage(details, 0, 0, size, size);
    }
    function announce() {
      for (const [i, b] of [...thumbs.children].entries()) b.setAttribute("aria-pressed", String(i === index));
      surface.dataset.selectedImage = String(index + 1);
      document.getElementById("galleryPosition").textContent = index + 1 + " / " + labels.length;
    }
    async function select(n) {
      index = (n + labels.length) % labels.length;
      announce();
      onSelect(index);
      if (context) await update({ ...context, view: "product" });
      const b = thumbs.children[index];
      if (b) thumbs.scrollTo({ left: b.offsetLeft - (thumbs.clientWidth - b.clientWidth) / 2, behavior: "smooth" });
    }
    labels.forEach((label, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.dataset.galleryIndex = String(i);
      b.className = thumbnailClass;
      b.setAttribute("aria-label", "Show " + label.toLowerCase());
      const c = canvas(180);
      c.setAttribute("role", "img");
      c.setAttribute("aria-label", label);
      b.append(c);
      b.onclick = () => void select(i);
      thumbs.append(b);
      thumbCanvases.push(c);
    });
    for (const b of surface.querySelectorAll("[data-map-gallery-step]")) b.onclick = () => void select(index + Number(b.dataset.mapGalleryStep));
    attachSwipeGallery(surface, (d) => void select(index + d));
    surface.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        e.preventDefault();
        void select(index + (e.key === "ArrowLeft" ? -1 : 1));
      }
    });
    async function prepare(c) {
      const art = await load(c.svgUrl), artCanvas = canvas(1e3, Math.round(1e3 * art.naturalHeight / art.naturalWidth));
      artCanvas.getContext("2d").drawImage(art, 0, 0, artCanvas.width, artCanvas.height);
      const artData = artCanvas.getContext("2d", { willReadFrequently: true }).getImageData(0, 0, artCanvas.width, artCanvas.height);
      await frame(c.svgUrl, c.mm, c.finish);
      const snapshot = canvas(1500);
      snapshot.getContext("2d").drawImage(front, 0, 0);
      let framed;
      if (c.finish === "none") {
        await exampleFrame(c.svgUrl, c.mm, "natural-wood");
        framed = framedCrop(roomFrame, c.mm);
      } else framed = framedCrop(snapshot, c.mm);
      return { art, artData, front: snapshot, artworkRect: front.dataset.artworkRect, framed, mm: c.mm, finish: c.finish, colourway: c.colourway, frameColour: { "natural-wood": "#b99b77", "dark-wood": "#654a34", black: "#242424", white: "#fff" }[c.finish] || "#b99b77" };
    }
    async function update(c) {
      context = c;
      const current = ++version, nextKey = [c.svgUrl, c.finish, c.colourway, ...c.mm].join("|");
      if (key !== nextKey) {
        key = nextKey;
        prepared = prepare(c);
      }
      try {
        const p = await prepared;
        if (current !== version) return;
        const rendered = canvas(1200);
        await paint(rendered, c.view === "art" ? paperIndex : index, p);
        if (current !== version) return;
        output.width = 1200;
        output.height = 1200;
        output.getContext("2d").drawImage(rendered, 0, 0);
        output.setAttribute("aria-label", c.title + " \xB7 " + (c.view === "art" ? "Artwork only" : labels[index]) + " \xB7 " + c.finishLabel);
        output.dataset.artworkRect = p.artworkRect;
        output.dataset.personalisation = c.title;
        output.dataset.galleryScene = c.view === "art" ? "artwork" : String(index);
        output.setAttribute("aria-busy", "false");
        announce();
        onRender();
        if (deferThumbnails()) {
          thumbnailKey = "";
          ++thumbVersion;
          return;
        }
        if (thumbnailKey === nextKey) return;
        thumbnailKey = nextKey;
        const generation = ++thumbVersion;
        void (async () => {
          for (let i = 0; i < labels.length; i++) {
            if (generation !== thumbVersion || deferThumbnails()) {
              thumbnailKey = "";
              return;
            }
            await new Promise((r) => setTimeout(r, 0));
            if (deferThumbnails()) {
              thumbnailKey = "";
              return;
            }
            const tile = canvas(180);
            await paint(tile, i, p, 180);
            if (generation !== thumbVersion) return;
            thumbCanvases[i].getContext("2d").drawImage(tile, 0, 0);
            thumbCanvases[i].dataset.personalisation = c.title;
          }
        })().catch(() => {
          if (generation === thumbVersion) thumbnailKey = "";
        });
      } catch (e) {
        if (current === version) {
          const status = surface.closest("product-page")?.querySelector("[data-editor-status]") || document.getElementById("status");
          if (status) status.textContent = e.message;
          output.setAttribute("aria-busy", "false");
        }
      }
    }
    announce();
    return { update, select, get label() {
      return labels[index];
    }, get index() {
      return index;
    }, get isRoom() {
      return index >= 1 && index <= (custom ? 6 : 4);
    } };
  }

  // personalisation-product-integration/city-map-pilot/colourways.mjs
  var COLOURWAYS = [
    { id: "ink", title: "Black on ivory", detail: "Off-white paper & charcoal", paper: "#faf8f3", base: "#faf8f3", park: "#e8e7df", building: null, water: "#d2d7d3", waterway: "#8b9590", railway: "#92968e", path: "#a3a69f", minor: "#686e65", major: "#292f29", label: "#272c27", footer: "#eeeae1" },
    { id: "black-white", title: "Black & white", detail: "Pure white paper & black", paper: "#ffffff", base: "#ffffff", park: "#ffffff", building: null, water: "#000000", waterway: "#000000", railway: "#000000", path: "#000000", minor: "#000000", major: "#000000", label: "#000000", footer: "#ffffff" },
    { id: "sage", title: "Sage green", detail: "Off-white paper & botanical greens", paper: "#faf8f1", base: "#faf8f1", park: "#e0e7d9", building: null, water: "#b9c8b8", waterway: "#789379", railway: "#a0ae95", path: "#a6b39b", minor: "#789174", major: "#435f49", label: "#354c3b", footer: "#e0e7d9" },
    { id: "terracotta", title: "Terracotta", detail: "Off-white paper & warm clay", paper: "#fbf8f1", base: "#fbf8f1", park: "#eae5d9", building: null, water: "#dec5b5", waterway: "#b99079", railway: "#b9a38e", path: "#ccb7a2", minor: "#b88769", major: "#965b42", label: "#724631", footer: "#ead8c8" },
    { id: "slate", title: "Slate blue", detail: "Off-white paper & muted blue", paper: "#faf9f4", base: "#faf9f4", park: "#e1e6df", building: null, water: "#c0d0d5", waterway: "#839da8", railway: "#a5b1b1", path: "#b0bdbd", minor: "#829da8", major: "#496572", label: "#354d5b", footer: "#dce5e7" },
    { id: "taupe", title: "Warm taupe", detail: "Off-white paper & soft earth", paper: "#faf8f1", base: "#faf8f1", park: "#e7e3d7", building: null, water: "#d3ccc0", waterway: "#a69a88", railway: "#b6ab98", path: "#beb4a0", minor: "#a19580", major: "#6e624e", label: "#554b3e", footer: "#e4ded2" }
  ];
  var DEFAULT_COLOURWAY = "ink";

  // personalisation-product-integration/personalised-side-cart.mjs
  async function showPersonalisedSideCart(root2, response) {
    const items = document.getElementById("AjaxCartForm"), subtotal = document.getElementById("AjaxCartSubtotal"), sidebar = document.getElementById("site-cart-sidebar");
    if (!items || !subtotal || typeof sidebar?.show !== "function") return false;
    const text = typeof window.labooCartSectionText === "function" ? await window.labooCartSectionText(response) : await fetch((window.Shopify?.routes?.root || "/") + "?section_id=helper-cart").then((r) => {
      if (!r.ok) throw Error("Cart refresh failed");
      return r.text();
    });
    const section = new DOMParser().parseFromString(text, "text/html"), nextItems = section.getElementById("AjaxCartForm"), nextSubtotal = section.getElementById("AjaxCartSubtotal");
    if (!nextItems || !nextSubtotal) throw Error("Cart refresh failed");
    items.innerHTML = nextItems.innerHTML;
    items.ajaxifyCartItems?.();
    subtotal.innerHTML = nextSubtotal.innerHTML;
    const count = items.querySelector("[data-cart-count]")?.textContent, total = items.querySelector("[data-cart-total]")?.textContent;
    if (count != null) document.querySelectorAll("[data-header-cart-count]").forEach((e) => e.textContent = count);
    if (total != null) document.querySelectorAll("[data-header-cart-total]").forEach((e) => e.textContent = total);
    root2.closest("dialog")?.close();
    sidebar.show();
    document.getElementById("cart-recommendations-sidebar")?.generateRecommendations?.();
    document.getElementById("screen-reader-info")?.replaceChildren(document.createTextNode("Your personalised print was added to your basket."));
    return true;
  }

  // personalisation-product-integration/city-map-pilot/native-map-editor.mjs
  var root = document.querySelector("[data-laboo-native-map-fields]");
  if (root) start().catch((e) => {
    root.hidden = false;
    root.querySelector("[data-editor-status]").textContent = e.message || "Please reload to load your map.";
  });
  async function start() {
    const page = root.closest("product-page"), form = root.closest("form"), button = form.querySelector("[name=add]"), status = root.querySelector("[data-editor-status]"), variantInput = form.querySelector("[name=id]");
    const $ = (selector) => root.querySelector(selector), country = root.dataset.country || "GB";
    const locationPostalLabel = country === "US" ? "ZIP code" : "postcode";
    $("[data-map-query]").placeholder = "Address, " + locationPostalLabel + " or landmark";
    const r = await fetch(root.dataset.configUrl + "?country=" + encodeURIComponent(country), { credentials: "omit" }), config = await r.json();
    if (!r.ok) throw Error(config.error || "This map is unavailable for your destination.");
    if (config.production.productId !== root.dataset.productId || config.production.template !== root.dataset.template) throw Error("The map settings could not be verified. Please reload.");
    root.querySelector("[data-map-zoom]").dataset.mapZoom = String(config.city.zoom);
    const actual = new Map(JSON.parse($("[data-map-variant-prices]").textContent).map((v) => [String(v.id), v]));
    const sizes = new Map(config.sizes.map((s) => [String(s.variantId), s]));
    for (const s of sizes.values()) {
      const a = actual.get(String(s.variantId));
      if (!a || !Number.isInteger(a.price)) throw Error("The print price could not be verified.");
      s.pricePence = a.price;
    }
    const money = (p) => new Intl.NumberFormat("en-GB", { style: "currency", currency: root.dataset.currency || "GBP" }).format(p / 100);
    let state = { ...structuredClone(config.defaults), confirmed: false, finish: "none", colourway: config.defaults.colourway || DEFAULT_COLOURWAY };
    const draftKey = "labooNativeMap:" + config.production.template + ":" + country;
    try {
      const saved = JSON.parse(sessionStorage.getItem(draftKey));
      if (saved?.fields && saved?.location && COLOURWAYS.some((c) => c.id === saved.colourway)) state = { ...state, fields: saved.fields, location: saved.location, confirmed: !!saved.confirmed, colourway: saved.colourway };
    } catch {
    }
    let revision = 0, rendered = -1, timer, artUrl, flow, previewKey = "", savedProof, savedProofKey = "", saveAttempt, busy = false;
    const size = () => sizes.get(variantInput.value), selectedFinish = () => flow?.getSelection().finish || "none";
    const modelFor = (id) => {
      const s = sizes.get(String(id));
      if (!s) return null;
      const unit = country === "US" ? "in" : "cm", div = unit === "in" ? 25.4 : 10, fmt = (n) => String(Number((n / div).toFixed(2))), prefix = /^a[0-4]$/.test(s.id) && !["US", "CA"].includes(country) ? s.id.toUpperCase() + " \xB7 " : "";
      return { mm: s.mm, label: prefix + s.label, widthText: fmt(s.mm[0]) + " " + unit, heightText: fmt(s.mm[1]) + " " + unit, country, unit, personLabel: country === "US" ? "Person: 5 ft 10 in" : "Person: 178 cm" };
    };
    const getOffer = (source, finish) => {
      const p = Object.values(config.purchases).find((p2) => p2.sourceVariantId === String(source) && p2.finish === finish), a = actual.get(String(p?.purchaseVariantId)), print = actual.get(String(source));
      return p && a?.available && print?.available && Number.isInteger(a.price) && a.price >= print.price ? { ...p, pricePence: a.price, upgradePence: a.price - print.price, currency: root.dataset.currency || "GBP" } : null;
    };
    const selection = () => {
      const finish = selectedFinish(), s = size();
      if (!s || !actual.get(String(s.variantId))?.available) throw Error("Choose an available print size.");
      const offer = finish === "none" ? null : getOffer(s.variantId, finish);
      if (finish !== "none" && !offer) throw Error("This frame is unavailable for your size and destination.");
      return { template: config.production.template, revision: config.production.revision, country, variantId: s.variantId, purchaseVariantId: offer?.purchaseVariantId || s.variantId, finish, fields: { ...state.fields }, location: { ...state.location }, colourway: state.colourway };
    };
    async function post(route, payload) {
      const response = await fetch(config.production.api + "/" + route, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), signal: AbortSignal.timeout(6e4), credentials: "omit" });
      if (route === "preview" && response.ok) return response.text();
      const j = await response.json();
      if (!response.ok) throw Error(j.error || "Please try again.");
      return j;
    }
    const describe = () => [state.fields.placeLabel, state.fields.names].filter(Boolean).join(" \xB7 ");
    const valid = () => !!state.confirmed && !!state.fields.placeLabel.trim() && rendered === revision && !busy;
    function updateButton() {
      button.disabled = busy || !valid() || !config.checkoutEnabled || flow?.canSubmit() === false;
      button.setAttribute("aria-disabled", String(button.disabled));
    }
    const surface = page.querySelector("[data-preview-gallery]"), canvas2 = surface.querySelector("canvas"), caption = surface.querySelector("[data-gallery-caption]");
    const loadingOverlay = document.createElement("div");
    loadingOverlay.className = "native-map-preview-loading";
    loadingOverlay.hidden = true;
    loadingOverlay.setAttribute("aria-hidden", "true");
    loadingOverlay.innerHTML = '<span class="native-map-loading-spinner"></span><span>Updating your map\u2026</span>';
    canvas2.parentElement.append(loadingOverlay);
    const loadingStatus = document.createElement("p");
    loadingStatus.className = "native-map-update-status";
    loadingStatus.hidden = true;
    loadingStatus.setAttribute("role", "status");
    loadingStatus.setAttribute("aria-live", "polite");
    loadingStatus.setAttribute("aria-atomic", "true");
    root.querySelector(".native-map-zoom").after(loadingStatus);
    function setPreviewLoading(loading, error = "") {
      surface.setAttribute("aria-busy", String(loading));
      surface.classList.toggle("native-map-preview-pending", loading);
      loadingOverlay.hidden = !loading;
      loadingStatus.hidden = !loading && !error;
      loadingStatus.textContent = loading ? "Updating your map\u2026" : error;
    }
    let focusGuide;
    const gallery = createLiveMapGallery({ getCompanionArt: createCompanionMapArtwork(config.production.api, config.defaults.design), onRender: () => {
      syncEnlargedPreview();
      focusGuide?.refresh();
    }, glazingBase: root.dataset.roomGlazingBase, roomManifest: JSON.parse(root.querySelector("[data-map-room-scenes]")?.textContent || "null"), surface, output: canvas2, thumbs: page.querySelector(".laboo-gallery-thumbnails"), assetBase: new URL("/city-map-assets/", config.production.api), frameUrl: config.production.frameOverlay, frameDetailsUrl: root.dataset.frameDetailsUrl, thumbnailClass: "laboo-gallery-thumbnail", extraScenes: root.dataset.giftingUrl ? [{ label: "Gifting example", url: root.dataset.giftingUrl }] : [], deferThumbnails: () => isPreviewFirstPilot(root) && window.matchMedia("(max-width:767px)").matches && !!surface.closest("dialog[open]"), onSelect() {
      void drawGallery();
    } });
    const finishPreview = createFramePreviewChoices(page.querySelector("[data-map-preview-finishes]"), { followPurchase: isPreviewFirstPilot(root), onChange: () => void drawGallery() });
    async function drawGallery() {
      if (!artUrl || !size()) return;
      finishPreview.update(modelFor(variantInput.value), { getOffer: (f) => getOffer(variantInput.value, f), requireOffer: true, purchaseFinish: selectedFinish() });
      const finish = finishPreview.getFinish();
      await gallery.update({ svgUrl: artUrl, mm: size().mm, colourway: state.colourway, finish, title: state.fields.placeLabel, finishLabel: finish === "none" ? "Print only" : config.finishes.find((f) => f[0] === finish)?.[1], view: "product" });
      caption.textContent = gallery.label === "Gifting example" ? "Gifting example \xB7 Paris \xB7 Natural wood frame" : (gallery.label === "Print only" ? "Print only" : gallery.label + " \xB7 " + (finish === "none" ? gallery.isRoom ? "Natural wood frame example - frame optional" : "Print only" : config.finishes.find((f) => f[0] === finish)?.[1])) + " \xB7 " + describe();
    }
    for (const key of ["placeLabel", "subtitle", "heading", "names", "date"]) {
      const field = $("[data-map-field=" + key + "]");
      field.value = state.fields[key] || "";
      field.addEventListener("input", () => {
        state.fields[key] = field.value;
        queue();
      });
    }
    function paintLocation() {
      $("[data-map-selected-location]").textContent = (state.confirmed ? "Selected: " : "Example: ") + (state.location.label || config.city.title);
      for (const b of root.querySelectorAll("[data-map-zoom]")) b.setAttribute("aria-pressed", String(Number(b.dataset.mapZoom) === state.location.zoom));
    }
    paintLocation();
    for (const colour of COLOURWAYS) {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "native-map-colour";
      b.dataset.colourway = colour.id;
      b.setAttribute("aria-label", colour.title);
      b.title = colour.title;
      b.append(document.createElement("span"));
      b.onclick = () => {
        state.colourway = colour.id;
        paintColours();
        queue();
      };
      $("[data-map-colours]").append(b);
    }
    function paintColours() {
      for (const b of root.querySelectorAll("[data-colourway]")) b.setAttribute("aria-pressed", String(b.dataset.colourway === state.colourway));
      $("[data-map-colour-name]").textContent = COLOURWAYS.find((c) => c.id === state.colourway).title;
    }
    paintColours();
    async function search() {
      const query = $("[data-map-query]").value.trim();
      if (query.length < 3) {
        status.textContent = "Enter an address, " + locationPostalLabel + " or landmark.";
        return;
      }
      const b = $("[data-map-search]"), results = $("[data-map-search-results]");
      b.disabled = true;
      status.textContent = "Finding matching places\u2026";
      results.replaceChildren();
      try {
        const j = await post("map-search", { template: config.production.template, query });
        for (const p of j.results) {
          const hit = document.createElement("button");
          hit.type = "button";
          hit.textContent = p.label;
          hit.onclick = () => {
            state.location = { latitude: p.latitude, longitude: p.longitude, zoom: state.location.zoom, label: p.label };
            state.confirmed = true;
            results.replaceChildren();
            paintLocation();
            queue();
          };
          results.append(hit);
        }
        status.textContent = j.results.length ? "Choose the matching place above." : "No matching place found. Try the address with " + config.city.title + ".";
      } catch (e) {
        status.textContent = e.message;
      } finally {
        b.disabled = false;
      }
    }
    $("[data-map-search]").onclick = search;
    $("[data-map-query]").addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        void search();
      }
    });
    $("[data-map-use-city]").onclick = () => {
      state.location = structuredClone(config.defaults.location);
      state.confirmed = true;
      paintLocation();
      queue();
    };
    for (const b of root.querySelectorAll("[data-map-zoom]")) b.onclick = () => {
      state.location.zoom = Number(b.dataset.mapZoom);
      paintLocation();
      queue();
    };
    const linkedPurchase = config.purchases[new URL(location.href).searchParams.get("variant")];
    const sourceFromPurchase = linkedPurchase?.sourceVariantId;
    if (sourceFromPurchase && sizes.has(sourceFromPurchase)) variantInput.value = sourceFromPurchase;
    if (!sizes.has(variantInput.value) || !actual.get(variantInput.value)?.available) variantInput.value = [...sizes.keys()].find((id) => actual.get(id)?.available) || "";
    const variants = Object.fromEntries([...sizes].map(([id, s]) => [id, { mm: s.mm, originalTitle: s.label }]));
    const proofSaveKey = () => JSON.stringify([selection(), flow?.getGiftKey() || null]);
    const initialFinish = linkedPurchase && getOffer(variantInput.value, linkedPurchase.finish) ? linkedPurchase.finish : "none";
    const extraFields = $(".native-map-extra");
    if (extraFields && (isPreviewFirstPilot(root) || config.defaults.design === "our-place" || state.fields.names || state.fields.date)) extraFields.open = true;
    flow = setupMobileLayout(root, { variants, getSizeModel: modelFor, getFrameOffer: getOffer, initialFinish, describePrint: describe, proofType: "map", validationMessage: "Choose your map location and title, then wait for the preview.", returnsText: "Made just for you. No change-of-mind returns or refunds. Your rights if your item is damaged, faulty or not as described are unaffected. Please check your map location, words, size and frame before adding to your basket.", validatePrint: valid, prepareProof: async () => {
      if (!valid()) throw Error("Choose your place and wait for your updated map preview.");
      const key = proofSaveKey(), gift = flow?.getGift() || null, rev = revision;
      if (savedProof && savedProofKey === key) return savedProof;
      if (saveAttempt?.key !== key) saveAttempt = { key, id: crypto.randomUUID() };
      const result = await post("save", { ...selection(), gift, requestId: saveAttempt.id });
      if (rev !== revision || key !== proofSaveKey()) throw Error("Your design changed. Prepare a new proof.");
      if (result.engine !== "city-map-v1" || String(result.productId) !== root.dataset.productId || result.previewOnly || !/^\w{64}$/.test(result.sha256) || !result.fileUrl?.startsWith(new URL(config.production.api).origin + "/shopify-artwork/")) throw Error("Your saved map proof could not be verified.");
      savedProof = { ...result, personalisationType: "map", personalisationSummary: describe() };
      savedProofKey = key;
      return savedProof;
    }, onChange: updateButton, onOpen: () => {
      void drawGallery();
    } });
    if (!flow) throw Error("The shared personaliser could not start. Please reload.");
    if (isPreviewFirstPilot(root)) focusGuide = createMapFieldFocusGuide({ root, surface, canvas: canvas2, design: config.defaults.design, showPrint: () => void gallery.select(0) });
    root.hidden = false;
    page.classList.add("laboo-native-map");
    form.addEventListener("change", (e) => {
      if (e.target === variantInput) queue();
    });
    new MutationObserver(queue).observe(variantInput, { attributes: true, attributeFilter: ["value"] });
    root.addEventListener("laboo:finish-change", queue);
    let lastVariant = variantInput.value;
    const watcher = setInterval(() => {
      if (!root.isConnected) {
        clearInterval(watcher);
        return;
      }
      if (lastVariant !== variantInput.value) {
        lastVariant = variantInput.value;
        queue();
      }
    }, 300);
    for (const node of page.querySelectorAll(".single-variant")) if (sizes.has(node.dataset.pVariantId)) node.addEventListener("click", () => {
      variantInput.value = node.dataset.pVariantId;
      variantInput.setAttribute("value", node.dataset.pVariantId);
    });
    function queue() {
      revision++;
      rendered = -1;
      savedProof = null;
      savedProofKey = "";
      flow?.invalidateProof();
      status.textContent = "Updating your map\u2026";
      setPreviewLoading(true);
      updateButton();
      try {
        sessionStorage.setItem(draftKey, JSON.stringify(state));
      } catch {
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        void preview();
      }, 220);
    }
    async function preview() {
      const rev = revision;
      let error = "";
      try {
        const key = JSON.stringify(selection()), svg = await post("preview", selection());
        if (rev !== revision) return;
        focusGuide?.setSVG(svg, size().mm);
        const old = artUrl;
        artUrl = URL.createObjectURL(new Blob([svg], { type: "image/svg+xml" }));
        await drawGallery();
        if (rev !== revision) return;
        flow.setPreview(artUrl, describe());
        if (old) URL.revokeObjectURL(old);
        rendered = rev;
        previewKey = key;
        status.textContent = state.confirmed ? "" : "Choose your address, or use " + config.city.title + " city centre.";
        updateButton();
      } catch (e) {
        if (rev === revision) {
          error = e.message || "Your map could not update. Please try again.";
          status.textContent = error;
          updateButton();
        }
      } finally {
        if (rev === revision) setPreviewLoading(false, error);
      }
    }
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy || !flow.beforeSubmit() || !valid()) return;
      const proof = flow.getProof(), key = JSON.stringify(selection());
      if (!proof || proof !== savedProof || proofSaveKey() !== savedProofKey || key !== previewKey) {
        status.textContent = "Check and approve a fresh final proof.";
        return;
      }
      busy = true;
      updateButton();
      status.textContent = "Recording your proof approval\u2026";
      try {
        const approved = await post("approve", { ticketToken: new URL(proof.customerProofUrl).pathname.split("/").at(-1), sha256: proof.sha256, confirmed: true });
        if (!approved.approved || approved.sha256 !== proof.sha256) throw Error("Your print approval could not be recorded.");
        const properties = Object.fromEntries(proof.orderProperties.map((p) => [p.name, p.value]));
        Object.assign(properties, { "Print size": proof.size, _Laboo_Design_ID: proof.designId, _Laboo_Proof_URL: proof.customerProofUrl, _Laboo_Preview_URL: proof.cartPreviewUrl || proof.previewUrl, _Laboo_Proof_System: "city-map-v1", _Laboo_Proof_Stage: "before_checkout", _Laboo_Map_Credits: "Packaging" });
        Object.assign(properties, giftOrderProperties(proof.gift));
        if (proof.purchaseVariantId) Object.assign(properties, { Frame: proof.frameLabel, Assembly: "Ready to hang" });
        const route = window.Shopify?.routes?.root || "/", cartRequest = isPreviewFirstPilot(root) && typeof window.labooCartRequest === "function" ? window.labooCartRequest : window.fetch.bind(window), add = await cartRequest(route + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: proof.purchaseVariantId || proof.variantId, quantity: 1, properties }] }) }), added = typeof add.json === "function" ? await add.json() : add;
        if (add.ok === false || added.status >= 400) throw Error(added.description || "Your print could not be added.");
        if (isPreviewFirstPilot(root)) {
          try {
            if (await showPersonalisedSideCart(root, added)) {
              busy = false;
              updateButton();
              return;
            }
          } catch {
          }
        }
        location.assign(route + "cart");
      } catch (e2) {
        busy = false;
        status.textContent = e2.message;
        updateButton();
      }
    }, true);
    const enlarge = page.querySelector("[data-map-enlarge]");
    const lightbox = page.querySelector("[data-map-lightbox]"), largeCanvas = lightbox.querySelector("canvas"), closeLarge = lightbox.querySelector("button");
    closeLarge.setAttribute("aria-label", "Close enlarged preview");
    const largeStage = document.createElement("div");
    largeStage.className = "laboo-room-lightbox-image";
    largeCanvas.before(largeStage);
    largeStage.append(largeCanvas);
    largeStage.style.cssText = "position:relative;display:grid;place-items:center;min-height:0";
    largeCanvas.style.cssText = "display:block;max-width:100%;max-height:78dvh;width:auto;height:auto;object-fit:contain";
    const largeCaption = document.createElement("p");
    largeCaption.setAttribute("aria-live", "polite");
    largeCaption.style.cssText = "text-align:center;font:13px Arial,sans-serif;margin:10px";
    lightbox.append(largeCaption);
    async function moveLarge(direction) {
      lightbox.setAttribute("aria-busy", "true");
      try {
        await gallery.select(gallery.index + direction);
      } finally {
        lightbox.setAttribute("aria-busy", "false");
        syncEnlargedPreview();
      }
    }
    for (const [direction, label] of [[-1, "Previous enlarged image"], [1, "Next enlarged image"]]) {
      const b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", label);
      b.dataset.swipeIgnore = "true";
      b.className = "laboo-room-arrow laboo-room-arrow--" + (direction < 0 ? "prev" : "next");
      b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (direction < 0 ? "M15 5L8 12L15 19" : "M9 5L16 12L9 19") + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.style.cssText = "position:absolute;top:50%;transform:translateY(-50%);" + (direction < 0 ? "left" : "right") + ":10px;width:44px;height:44px;border:0;border-radius:50%;background:#fff;color:#222;box-shadow:0 2px 9px #0003;display:grid;place-items:center;cursor:pointer;z-index:2";
      b.onclick = () => void moveLarge(direction);
      largeStage.append(b);
    }
    attachSwipeGallery(largeStage, (d) => void moveLarge(d));
    lightbox.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        e.preventDefault();
        void moveLarge(e.key === "ArrowLeft" ? -1 : 1);
      }
    });
    function syncEnlargedPreview() {
      const viewer = page.querySelector("[data-map-lightbox]");
      if (!viewer?.open) return;
      const c = viewer.querySelector("canvas");
      c.width = canvas2.width;
      c.height = canvas2.height;
      c.getContext("2d").drawImage(canvas2, 0, 0);
      c.setAttribute("aria-label", (canvas2.getAttribute("aria-label") || "Your preview") + ", enlarged");
      const p = viewer.querySelector("p[aria-live]");
      if (p) p.textContent = gallery.label + " - " + (gallery.index + 1) + " / " + page.querySelectorAll(".laboo-gallery-thumbnails button").length;
    }
    enlarge.onclick = () => {
      lightbox.showModal();
      syncEnlargedPreview();
    };
    surface.addEventListener("click", (e) => {
      if (e.target.closest(".laboo-original-art-stage")) enlarge.click();
    });
    closeLarge.onclick = () => lightbox.close();
    queue();
  }
})();
